const ruLocale = {
    common: {
        Save: "Сохранить",
        Send: "Отправить",
        Cancel: "Отмена",
        Delete: "Удалить",
        Remove: "Удалить",
        Add: "Добавить",
        Restore: "Восстановить",
        Retry: "Повторить попытку",
        Search: "Поиск",
        Reset: "Сбросить",
        Contract: "Договор",
        AddGuardian: "Добавить опекуна",
        Filter: "Фильтр",
        ApplyFilter: "Применить фильтр",
        ClearFilters: "Очистить фильтры",
        Detail: "Детали",
        Objects: "Объекты",
        Actions: "Действия",
        SelectOption: "Выберите опцию",
        SearchByName: "Поиск по имени или личному коду",
        SearchByNameOrCode: "Поиск по имени или коду",
        SearchByNameAndCode: "Поиск по имени и коду",
        SearchByCode: "Поиск по коду",
        BookingSystem: "Система бронирования",
        PageNotFound: "Страница не найдена",
        PageNotFoundDescription: "Запрашиваемая страница не существует.",
        BackToDashboard: "Вернуться на главную",
        SearchByType: "Фильтр по типу",
        SearchBySex: "Фильтр по полу",
        SearchByResidentType: "Фильтр по типу жителя",
        SearchByMunicipality: "Фильтр по муниципалитету",
        SearchByDocumentType: "Фильтр по типу документа",
        SearchByNotes: "Поиск по заметкам",
        SearchByDescription: "Поиск по описанию",
        SearchByMenu: "Поиск по содержанию меню",
        People: "человек",
        FilterByStatus: "Фильтр по статусу",
        FilterByActive: "Фильтр по активности",
        FilterByType: "Фильтр по типу",
        FilterByUnitType: "Фильтр по типу единицы",
        FilterByPackageType: "Фильтр по типу упаковки",
        FilterByManufacturer: "Фильтр по производителю",
        FilterByMunicipality: "Фильтр по муниципалитету",
        FilterByContractType: "Фильтр по типу контракта",
        ComingSoon: "Скоро будет",
        FilterByLevel: "Фильтр по уровню",
        FilterByResident: "Фильтр по жителю",
        SearchByContractId: "Поиск по ID контракта",
        SelectContractType: "Выберите тип контракта",
        EnterContractId: "Введите ID контракта",
        SelectResidentOrGuardian: "Выберите жителя или опекуна",
        ResidentOrGuardianRequired: "Пожалуйста, выберите жителя или опекуна",
        SelectDocument: "Выберите документ",
        SelectDocumentType: "Выберите тип документа",
        EnterVersion: "Введите версию",
        EnterComments: "Введите комментарии",
        FirstName: "Имя",
        LastName: "Фамилия",
        Phone: "Телефон",
        PhoneNumber: "Номер телефона",
        Email: "Электронная почта",
        FirstNameRequired: "Имя обязательно",
        LastNameRequired: "Фамилия обязательна",
        PhoneRequired: "Номер телефона обязателен",
        EmailRequired: "Адрес электронной почты обязателен",
        InvalidEmail: "Пожалуйста, введите корректный адрес электронной почты",
        StartDateRequired: "Дата начала обязательна",
        EndDateOptional: "Дата окончания необязательна",
        EndDateRequired: "Дата окончания обязательна",
        DateRangeRequired: "Диапазон дат обязателен",
        ContractTypeRequired: "Тип контракта обязателен",
        CalculationSetupRequired: "Настройка расчета обязательна",
        DocumentRequired: "Документ обязателен",
        Reason: "Причина",
        OptionalField: "Необязательное поле",
        ReadOnlyField: "Это поле только для чтения",
        Sunday: "Воскресенье",
        Monday: "Понедельник",
        Tuesday: "Вторник",
        Wednesday: "Среда",
        Thursday: "Четверг",
        Friday: "Пятница",
        Saturday: "Суббота",
        MunicipalityNameRequired: "Название муниципалитета обязательно",
        MunicipalityCodeRequired: "Код муниципалитета обязателен",
        MunicipalitySupportRequired: "Поддержка муниципалитета обязательна",
        MonthlyPaymentRequired: "Ежемесячный платеж обязателен",
        Setup: "Настройки",
        SelectCalculationSetup: "Выберите настройку расчета",
        ManageCalculationSetups: "Управление настройками расчета",
        MunicipalityName: "Название муниципалитета",
        MunicipalityCode: "Код муниципалитета",
        ContractType: "Тип контракта",
        SupportedFormats: "Поддерживаемые форматы",
        Documents: "Документы",
        StartDate: "Дата начала",
        EndDate: "Дата окончания",
        NoEndDate: "Дата окончания отсутствует",
        RequiredFields: "Обязательные поля",
        NoAddressesFound: "Адреса не найдены",
        TypeAtLeast3Characters: "Пожалуйста, введите не менее 3 символов для поиска адреса",
        AddressNotFound: "Адрес не найден",
        Forbidden: "Доступ запрещен",
        BrushColor: "Цвет кисти",
        Active: "Активный",
        Enabled: "Включено",
        Inactive: "Неактивный",
        Refresh: "Обновить",
        Menu: "Меню",
        Yes: "Да",
        No: "Нет",
        Name: "Название",
        Code: "Код",
        Description: "Описание",
        Translations: "Переводы",
        Translate: "Перевести",
        ShowFilters: "Показать фильтры",
        HideFilters: "Скрыть фильтры",
        ErrorLoadingData: "Ошибка загрузки данных",
        LoadingError: "Ошибка загрузки данных",
        SaveError: "Ошибка сохранения данных",
        DeleteError: "Ошибка удаления данных",
        ChangeType: "Тип изменения",
        ChangedFields: "Изменённые поля",
        NoFieldsChanged: "Поля не изменены",
        NoDataFound: "Данные не найдены",
        Success: "Успешно",
        Error: "Ошибка",
        SaveSuccess: "Успешно сохранено",
        CreateSuccess: "Успешно создано",
        UpdateSuccess: "Успешно обновлено",
        DeleteSuccess: "Успешно удалено",
        RestoreSuccess: "Успешно восстановлено",
        Edit: "Редактировать",
        ConfirmDeletion: "Подтвердить удаление",
        Today: "Сегодня",
        Clear: "Очистить",
        Selected: "Выбрано",
        Close: "Закрыть",
        FailedToLoadData: "Не удалось загрузить данные",
        History: "История",
        User: "Пользователь",
        Employee: "Сотрудник",
        CreatedOn: "Создано",
        CreatedBy: "Создатель",
        ModifiedOn: "Изменено",
        ModifiedBy: "Изменено пользователем",
        Period: "Период",
        Type: "Тип",
        View: "Просмотр",
        Resident: "Житель",
        ResidentFilter: "Житель",
        SearchForResident: "Поиск жителя...",
        SearchResidents: "Поиск жителей...",
        NoResidentsFound: "Жители не найдены",
        DateRange: "Диапазон дат",
        SelectDateRange: "Выберите диапазон дат",
        SelectDate: "Выберите дату",
        ListView: "Представление списка",
        Upload: "Загрузить",
        Create: "Создать",
        Facility: "Учреждение",
        Date: "Дата",
        Comments: "Комментарии",
        Note: "Примечание",
        Notes: "Содержание услуги",
        ServiceNotes: "Содержание услуги",
        Select: "Выбрать",
        Quantity: "Количество",
        FromDate: "С даты",
        ToDate: "По дату",
        FilterByArticle: "Фильтр по товару",
        Room: "Комната",
        SelectRoom: "Выберите комнату",
        Template: {
            Language: "Язык",
            Value: "Значение"
        },
        UnsavedChanges: "Несохраненные изменения",
        UnsavedChangesWarning: "У вас есть несохраненные изменения. Вы уверены, что хотите закрыть без сохранения?",
        CloseWithoutSaving: "Закрыть без сохранения",
        OpenInNewTab: "Открыть в новой вкладке",
        Optional: "Необязательно",
        AllMunicipalities: "Все муниципалитеты",
        Municipality: "Муниципалитет",
        SelectAll: "Выбрать все",
        SelectNone: "Отменить выбор",
        SelectMunicipality: "Выбрать муниципалитет",
        MunicipalityRequired: "Муниципалитет обязателен",
        MunicipalityLoadingError: "Ошибка загрузки муниципалитетов",
        ContractDetails: "Детали контракта",
        Status: "Статус",
        Days: "Дни",
        ExportToExcel: "Экспорт в Excel",
        Approve: "Утвердить",
        Approved: "Утверждено",
        Unapprove: "Отменить утверждение",
        Go: "Перейти",
        SelectAction: "Выберите действие",
        SelectedCount: "{count} выбрано",
        ClearSelection: "Очистить выбор",
        Adjust: "Скорректировать",
        Balanced: "Сбалансировано",
        Unbalanced: "Несбалансировано",
        Manual: "Ручной ввод",
        Calculated: "Вычислено",
        Back: "Назад",
        AddTemplate: "Добавить шаблон",
        Generate: "Сгенерировать",
        GenerateDocument: "Сгенерировать документ",
        GenerateFromTemplate: "Сгенерировать из шаблона",
        DocumentTemplate: "Шаблон документа",
        DocumentTemplateInfo: "Выберите шаблон документа для генерации контрактов",
        SelectTemplateToGenerate: "Выберите шаблон для генерации нового документа",
        TemplateRequired: "Пожалуйста, выберите шаблон документа",
        GenerateDocumentInfo: "Сгенерировать новый документ из выбранного шаблона с данными контракта",
        DocumentGeneratedSuccessfully: "Документ успешно сгенерирован",
        DocumentGenerationError: "Ошибка генерации документа",
        GenerateDocumentSuccess: "Документ успешно сгенерирован",
        GenerateDocumentError: "Ошибка генерации документа",
        GenerateError: "Ошибка генерации контракта и документа",
        SelectDocumentTemplate: "Пожалуйста, сначала выберите шаблон документа",
        DecisionNumber: "Номер решения",
        DecisionNumberRequired: "Номер решения обязателен",
        SelectMunicipalityContract: "Выберите муниципальный договор",
        MunicipalityContractRequired: "Муниципальный договор обязателен",
        SelectedContract: "Выбранный договор",
        Previous: "Предыдущий",
        Next: "Следующий",
        SelectServiceCalculationSetup: "Выберите настройку расчета услуг",
        IsActive: "Активен",
        JustNow: "Только что",
        MinutesAgo: "{minutes} минут назад",
        HoursAgo: "{hours} часов назад",
        ViewDetails: "Просмотр подробностей",
        NotSet: "Не установлено"
    },
    waitlist: {
        Waitlist: "Лист ожидания",
        SelectService: "Выберите услугу",
        Priority: "Приоритет",
        Status: "Статус",
        SubscribeClient: "Добавить клиента в лист ожидания",
        ClientId: "ID клиента",
        Notes: "Заметки",
        Subscribe: "Добавить",
        InvitesForSlot: "Приглашения для слота",
        Sent: "Отправлено",
        Expires: "Истекает",
        CreateInvite: "Создать приглашение",
        WaitlistId: "ID листа ожидания",
        WindowMinutes: "Окно (мин)",
        SendInvite: "Отправить приглашение",
        SubscriptionCreated: "Подписка на лист ожидания создана",
        EditSubscription: "Редактировать подписку на лист ожидания",
        InvalidBookingId: "Неверный ID бронирования",
        InviteDataIncomplete: "Данные приглашения неполные",
        InviteAccepted: "Приглашение принято",
        InviteDeclined: "Приглашение отклонено",
        PleaseProvideWaitlistAndBookingId: "Пожалуйста, укажите ID листа ожидания и ID бронирования",
        InviteSent: "Приглашение отправлено",
        BookingIdMissing: "ID бронирования отсутствует"
    },
    menu: {
        Dashboard: "Панель управления",
        Bookings: "Бронирования",
        Waitlist: "Лист ожидания",
        Clients: "Клиенты",
        Services: "Услуги",
        Employees: "Сотрудники",
        Reports: "Отчёты",
        Rooms: "Комнаты",
        Settings: "Настройки",
        Residents: "Жители",
        Documents: "Документы",
        Observations: "Наблюдения",
        FoodMenu: "Меню питания",
        ScheduledActivity: "Запланированные мероприятия",
        Accounting: "Бухгалтерия",
        Stock: "Запасы",
        AddNew: "Добавить новый",
        SaveSuccess: "Сохранено успешно",
        UnsavedChangesWarning: "У вас есть несохраненные изменения. Вы уверены, что хотите закрыть без сохранения?",
        UnsavedChanges: "Несохраненные изменения",
        CloseWithoutSaving: "Закрыть без сохранения",
    },
    report: {
        ClientServiceVisitsTitle: "Отчёт по посещениям услуг клиентами",
        ClientServiceHistoryTitle: "История услуг клиента",
        BookingCancellationsTitle: "Отмена бронирований",
        SelectServices: "Выберите услуги",
        SelectClient: "Выберите клиента или ребёнка",
        VisitDateRange: "Диапазон дат посещений",
        NoData: "Данные отчёта не найдены",
        ChildName: "Имя ребёнка",
        ParticipantName: "Участник",
        VisitCount: "Количество посещений",
        CancellationCount: "Количество отмен",
        LastVisitDate: "Последнее посещение",
        BookingStartTime: "Начало услуги",
        BookingEndTime: "Окончание услуги",
        CancellationDate: "Дата",
        CancellationTime: "Время",
        CancellationReason: "Причина отмены",
        CancellationReasonMissing: "Причина не указана",
        Duration: "Длительность",
        ContractCode: "Код договора",
        AccountingCode: "Бухгалтерский код",
        TotalAmount: "Итоговая сумма",
        VisitAmount: "Сумма за посещение",
        BookingNotes: "Содержание услуги",
        InternalComment: "Внутренний комментарий",
        BookingEmployee: "Сотрудник",
        ExportExcel: "Экспорт в Excel",
        OpenClientDetail: "Открыть детали клиента",
        OpenFullClientView: "Открыть полную карточку клиента",
        ClientNotFound: "Данные клиента не найдены",
        LoadFailed: "Не удалось загрузить отчёт",
        LoadClientFailed: "Не удалось загрузить данные клиента",
        LoadServicesFailed: "Не удалось загрузить услуги"
    },
    residents: {
        Resident: "Житель",
        Residents: "Жители",
        ResidentsPlural: "жителей",
        ResidentDetail: "Данные жителя",
        AddResident: "Добавить жителя",
        FirstName: "Имя",
        LastName: "Фамилия",
        IdentityCode: "Личный код",
        ResidentType: "Тип жителя",
        Sex: "Пол",
        BirthDate: "Дата рождения",
        Age: "Возраст",
        AgeCalculatedFromBirthDate: "Возраст автоматически рассчитывается по дате рождения",
        Address: "Адрес",
        Municipality: "Муниципалитет",
        PhoneNumber: "Номер телефона",
        ResidentPhoneNumber: "Номер телефона жителя",
        Guardians: "Опекуны",
        GuardianFirstName: "Имя опекуна",
        GuardianLastName: "Фамилия опекуна",
        GuardianEmail: "Email опекуна",
        GuardianPhone: "Телефон опекуна",
        Relationship: "Отношение",
        ResidentHistory: "История жильца",
        ResidentHistoryDescription: "Просмотр всех изменений этого жильца",
        NoHistoryFound: "История для этого жильца не найдена",
        ResidentContracts: "Договоры",
    },
    residentContract: {
        Contracts: "Договоры",
        ResidentContracts: "Договоры",
        ContractNumber: "Номер договора",
        FacilityContracts: "Договоры с учреждением",
        MunicipalityContracts: "Решение муниципалитета",
        FacilityContract: "Договор с учреждением",
        MunicipalityContract: "Решение с муниципалитетом",
        ContractType: "Тип договора",
        StartDate: "Дата начала",
        EndDate: "Дата окончания",
        ContactPerson: "Контактное лицо",
        Phone: "Телефон",
        Email: "Электронная почта",
        Municipality: "Муниципалитет",
        MunicipalitySupport: "Поддержка муниципалитета",
        Pension: "Пенсия",
        Allowance: "Пособие",
        IsLiablePersonAvailable: "Ответственное лицо доступно",
        ExtraFinanceSupport: "Дополнительная финансовая поддержка",
        MunicipalityExtraFunding: "Дополнительное финансирование муниципалитета",
        SelectContract: "Выберите договор",
        CurrentContract: "Текущий договор",
        NoContractsFound: "Договоры не найдены",
        ServiceCalculationSetup: "Настройка расчета услуг",
        Document: "Документ",
        Description: "Управление договорами жильца, включая договоры с учреждениями и муниципалитетами",
        AddContract: "Добавить договор",
        EditContract: "Редактировать договор",
        AddMunicipalityContract: "Добавить договор с муниципалитетом",
        EditMunicipalityContract: "Редактировать договор с муниципалитетом",
        DetailDialogComingSoon: "Форма деталей договора будет реализована в следующей фазе",
        MunicipalityDetailDialogComingSoon: "Форма деталей муниципального договора будет реализована в следующей фазе",
        CreateSuccess: "Договор успешно создан",
        UpdateSuccess: "Договор успешно обновлен",
        CreateResidentContract: "Создать договор резидента",
        ChooseMunicipalityContract: "Выберите муниципальный договор",
        MunicipalityContractDescription: "Сначала выберите существующий муниципальный договор или создайте новый. Этот договор будет использоваться как основа для договора резидента.",
        FillContractDetails: "Заполните детали договора",
        ContractDetailsDescription: "Теперь заполните конкретные детали для этого договора резидента, включая резидента/опекуна, даты и настройки расчетов.",
        Step1ChooseMunicipalityContract: "Выберите муниципальный договор",
        Step2FillContractDetails: "Заполните детали договора",
        ConfirmRestoreContract: "Вы уверены, что хотите восстановить договор {contractName} #{contractNumber}?",
        ContractRestored: "Договор успешно восстановлен",
        ResidentDeletedError: "Невозможно восстановить договор: резидент удален. Пожалуйста, сначала восстановите резидента.",
        // History
        ContractHistory: "История договора",
        ViewHistory: "Посмотреть историю",
        ChangeType: "Тип изменения",
        ChangedFields: "Измененные поля"
    },
    residentContractBooking: {
        BookingPeriods: "Периоды бронирования",
        AddBooking: "Добавить период бронирования",
        EditBooking: "Редактировать период бронирования",
        BookingPercentage: "Процент бронирования",
        BookingPercentageInfo: "Процент от обычной ставки для взимания платы в период бронирования (например, 70% для зарезервированных/забронированных периодов)",
        BookingPercentageRequired: "Процент бронирования обязателен",
        ReasonPlaceholder: "Введите причину периода бронирования (необязательно)",
        SaveSuccess: "Период бронирования успешно сохранен",
        OverlapWarning: "Обнаружено наложение диапазона дат",
        OverlapDetails: "Этот период бронирования пересекается с существующим бронированием. Пожалуйста, измените даты."
    },
    residentContractTimeOff: {
        TimeOffPeriods: "Периоды отсутствия",
        AddTimeOff: "Добавить период отсутствия",
        EditTimeOff: "Редактировать период отсутствия",
        DailyRate: "Дневная ставка",
        DailyRateInfo: "Фиксированная дневная ставка для взимания платы в период отсутствия (например, 45€ в день)",
        DailyRateRequired: "Дневная ставка обязательна",
        ReasonPlaceholder: "Введите причину периода отсутствия (необязательно)",
        SaveSuccess: "Период отсутствия успешно сохранен",
        OverlapWarning: "Обнаружено наложение диапазона дат",
        OverlapDetails: "Этот период отсутствия пересекается с существующим периодом отсутствия. Пожалуйста, измените даты."
    },
    residentMunicipalityContract: {
        AddContract: "Добавить муниципальный договор",
        EditContract: "Редактировать муниципальный договор",
        CreateSuccess: "Муниципальный договор успешно создан",
        UpdateSuccess: "Муниципальный договор успешно обновлен",
        MonthlyPayment: "Ежемесячный платеж",
        ExtraFinanceSupport: "Дополнительные деньги от родственников",
        MunicipalityExtraFunding: "Общая сумма дополнительных средств от муниципалитета (как указано в решении) за вычетом карманных денег",
        ResidentOtherResponsibilitiesCost: "Стоимость других обязательств резидента",
        MunicipalitySupport: "Поддержка муниципалитета",
        Pension: "Пенсия",
        Allowance: "Карманные деньги",
        IsLiablePersonAvailable: "Ответственное лицо доступно",
        IsSpecialCalculation: "Специальный расчет (муниципалитет)",
        IsSpecialCalculationHelp: "При включении используется специальная ветка Excel; суммы AF/AG/AH рассчитываются соответственно для выставления счета",
        ServiceFeeForFacility: "Расход на уход (K)",
        ServiceFeeForFacilityHelp: "Ежемесячная стоимость ухода для учреждения (столбец K в Excel)"
    },
    guardian: {
        Guardians: "Опекуны",
        FirstName: "Имя",
        LastName: "Фамилия",
        Phone: "Телефон",
        Email: "Электронная почта",
        Address: "Адрес",
        IdentityCode: "Код личности",
        Relationship: "Отношение",
        IsSendReport: "Отправить отчет",
        AddGuardian: "Добавить опекуна",
        EditGuardian: "Редактировать опекуна",
        DeleteGuardian: "Удалить опекуна",
        FirstNamePlaceholder: "Введите имя",
        LastNamePlaceholder: "Введите фамилию",
        PhonePlaceholder: "Введите номер телефона",
        EmailPlaceholder: "Введите адрес электронной почты",
        AddressPlaceholder: "Введите адрес",
        IdentityCodePlaceholder: "Введите код личности",
        SelectRelationship: "Выберите отношение",
        FirstNameRequired: "Имя обязательно",
        LastNameRequired: "Фамилия обязательна",
        RelationshipRequired: "Отношение обязательно",
        DeleteConfirmation: "Вы уверены, что хотите удалить опекуна {name}?",
        SaveSuccess: "Опекун успешно сохранен",
        DeleteSuccess: "Опекун успешно удален",
    },
    settings: {
        General: "Общие",
        Users: "Пользователи",
        Roles: "Роли",
        Lookups: "Классификаторы",
        Qualifications: "Квалификации",
        Services: "Услуги",
        ServicesManagement: "Управление услугами",
        UserManagement: "Управление пользователями",
        RoleManagement: "Управление ролями",
        Municipalities: "Муниципалитеты",
        LookupTypeName: "Название типа классификатора",
        UserDetail: "Данные пользователя",
        Username: "Имя пользователя",
        Password: "Пароль",
        Email: "Электронная почта",
        FirstName: "Имя",
        LastName: "Фамилия",
        RoleName: "Название роли",
        FacilityName: "Название учреждения",
        Settings: "Настройки",
        PublicHolidays: "Государственные праздники",
        AddPublicHoliday: "Добавить праздник",
        EditPublicHoliday: "Редактировать праздник",
        HolidayDate: "Дата",
        HolidayName: "Праздник",
        IsDayOff: "Выходной день",
        SearchPublicHoliday: "Поиск по дате или названию",
        PublicHolidayHelp: "Если праздник отмечен как выходной, он будет показан в календаре красным цветом, а индикаторы доступности сотрудников будут скрыты.",
        PublicHolidayCreated: "Праздник успешно добавлен",
        PublicHolidayUpdated: "Праздник успешно обновлен",
        PublicHolidayDeleted: "Праздник успешно удален",
        PublicHolidayLoadFailed: "Не удалось загрузить праздники",
        PublicHolidaySaveFailed: "Не удалось сохранить праздник",
        User: {
            ColorFieldTooltip: "Выберите цвет для идентификации этого пользователя в системе",
            UserRoles: "Роли пользователя",
            UserFacilities: "Учреждения пользователя",
        }
    },
    roles: {
        RoleCode: "Код роли",
        RoleName: "Название роли",
        RoleDetail: "Детали роли",
        Privileges: "Привилегии",
        PrivilegeName: "Название привилегии"
    },
    breadcrumb: {
        Home: "Главная",
        Dashboard: "Панель управления",
        Residents: "Жители",
        ResidentDetail: "Детали жителя",
        AddResident: "Добавить жителя",
        Services: "Услуги",
        Bookings: "Бронирования",
        Waitlist: "Лист ожидания",
        Qualifications: "Квалификации",
        Employees: "Сотрудники",
        EmployeeDetail: "Детали сотрудника",
        CreateEmployee: "Создать сотрудника",
        Clients: "Клиенты",
        ClientDetail: "Детали клиента",
        NewClient: "Новый клиент",
        Rooms: "Комнаты",
        Settings: "Настройки",
        Documents: "Документы",
        Stock: "Запасы",
        Articles: "Товары",
        ArticleDetail: "Детали товара",
        AddArticle: "Добавить товар",
        UserDetail: "Детали пользователя",
        AddUser: "Добавить пользователя",
        Lookups: "Классификаторы",
        LookupDetail: "Детали классификатора",
        AddLookup: "Добавить классификатор",
        Observations: "Наблюдения",
        ObservationDetail: "Детали наблюдения",
        AddObservation: "Добавить наблюдение",
        FoodMenu: "Меню питания",
        EditFoodMenu: "Изменить меню питания",
        AddFoodMenu: "Добавить меню питания",
        ScheduledActivities: "Запланированные мероприятия",
        ScheduledActivityDetail: "Детали запланированного мероприятия",
        AddScheduledActivity: "Добавить запланированное мероприятие",
        Invoices: "Архивы",
        AddInvoice: "Добавить архив",
        InvoiceDetail: "Детали архива",
        CalculationDetail: "Детали расчета",
        StockLevels: "Уровни запасов",
        AddLevel: "Добавить уровень",
        LevelDetail: "Детали уровня запаса",
        StockItems: "Товары склада",
        AddItem: "Добавить товар",
        ItemDetail: "Детали товара",
        StockMovements: "Движения склада",
        AddMovement: "Добавить движение",
        Security: "Безопасность",
        ActiveSessions: "Активные сеансы",
        MyProfile: "Мой профиль",
        MySchedule: "Мой график",
        MyAbsences: "Мои отсутствия",
        MyBookings: "Мои бронирования",
        MyPasses: "Мои абонементы",
        ServicePasses: "Абонементы на услуги",
        Suggestions: "Предложения",
        MySuggestions: "Мои предложения",
        Reports: "Отчёты",
        NotificationManagement: "Управление уведомлениями"
    },
    authentication: {
        Login: "Войти",
        Logout: "Выйти",
        Username: "Имя пользователя",
        Password: "Пароль",
        Email: "Электронная почта",
        ForgotPassword: "Забыли пароль?",
        ResetPassword: "Сбросить пароль",
        NewPassword: "Новый пароль",
        ConfirmPassword: "Подтвердить пароль",
        LoginError: "Неверное имя пользователя или пароль.",
        SessionExpired: "Ваша сессия истекла. Пожалуйста, войдите снова.",
        LoginSuccess: "Успешный вход!",
        LogoutSuccess: "Успешный выход!",
        ChangePasswordSuccess: "Пароль успешно изменен!",
        ForgotPasswordInstruction: "Введите ваш адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
        EnterEmail: "Введите ваш адрес электронной почты",
        SendResetLink: "Отправить ссылку для сброса",
        ResetEmailSent: "Если учетная запись с этим email существует, ссылка для сброса пароля была отправлена.",
        CheckYourEmail: "Пожалуйста, проверьте свою электронную почту для получения инструкций по сбросу",
        DidNotReceiveEmail: "Если вы не видите письмо, проверьте папку спама или запросите новую ссылку.",
        ResendEmail: "Отправить снова",
        ErrorSendingResetEmail: "Не удалось отправить письмо для сброса. Пожалуйста, попробуйте еще раз.",
        ResetEmailError: "Не удалось отправить письмо для сброса. Пожалуйста, попробуйте еще раз.",
        ResetPasswordInstruction: "Введите ваш новый пароль ниже.",
        EnterNewPassword: "Введите новый пароль",
        EnterConfirmPassword: "Подтвердите новый пароль",
        ConfirmNewPassword: "Подтвердите новый пароль",
        PasswordsDoNotMatch: "Пароли не совпадают",
        PasswordResetSuccess: "Пароль успешно сброшен! Перенаправляем на страницу входа...",
        PasswordResetSuccessful: "Пароль успешно сброшен!",
        PasswordResetError: "Не удалось сбросить пароль. Пожалуйста, попробуйте еще раз.",
        ErrorResettingPassword: "Не удалось сбросить пароль. Пожалуйста, попробуйте еще раз.",
        InvalidResetToken: "Недействительная ссылка для сброса",
        InvalidOrExpiredToken: "Эта ссылка для сброса недействительна или истекла",
        RequestNewResetLink: "Пожалуйста, запросите новый сброс пароля",
        RequestNewLink: "Запросить новую ссылку для сброса",
        InvalidResetTokenMessage: "Эта ссылка для сброса недействительна или истекла. Пожалуйста, запросите новый сброс пароля.",
        BackToLogin: "Вернуться к входу",
        ValidatingToken: "Проверка ссылки для сброса...",
        TokenExpired: "Эта ссылка для сброса истекла. Пожалуйста, запросите новую.",
        TokenAlreadyUsed: "Эта ссылка для сброса уже использована",
        PasswordRequirementsNotMet: "Пароль не соответствует требованиям"
    },
    profile: {
        ViewProfile: "Просмотр профиля",
        EditProfile: "Редактировать профиль",
        MyProfile: "Мой профиль",
        ChangePassword: "Изменить пароль",
        MySchedule: "Мой график",
        MyAbsences: "Мои отсутствия",
        MyBookings: "Мои бронирования",
        Username: "Имя пользователя",
        Email: "Электронная почта",
        Phone: "Телефон",
        FirstName: "Имя",
        LastName: "Фамилия",
        CurrentPassword: "Текущий пароль",
        NewPassword: "Новый пароль",
        ConfirmPassword: "Подтвердите пароль",
        PasswordHint: "Минимум 8 символов"
    },
    auth: {
        Username: "Имя пользователя",
        UsernameOrEmail: "Имя пользователя или email",
        EnterUsernameOrEmail: "Введите имя пользователя или email",
        Password: "Пароль",
        Login: "Войти",
        Logout: "Выйти",
        LoggedOut: "Вы вышли из системы",
        EnterUsername: "Введите имя пользователя",
        EnterPassword: "Введите пароль",
        LoginFailed: "Ошибка входа",
        LoginSuccessful: "Вход выполнен успешно",
        BookingSystemLogin: "Вход в систему бронирования",
        ContactAdminForAccess: "Свяжитесь с администратором для получения доступа",
        InsufficientPrivileges: "Недостаточно прав",
        SessionExpired: "Ваша сессия истекла",
        Register: "Регистрация",
        CreateYourAccount: "Создайте учетную запись",
        Email: "Электронная почта",
        EnterEmail: "Введите адрес электронной почты",
        FirstName: "Имя",
        LastName: "Фамилия",
        PhoneNumber: "Номер телефона (необязательно)",
        PreferredLanguage: "Предпочитаемый язык",
        SelectLanguage: "Выберите язык",
        EnterFirstName: "Введите ваше имя",
        EnterLastName: "Введите вашу фамилию",
        EnterPhoneNumber: "Введите ваш номер телефона",
        RegisterButton: "Создать учетную запись",
        PasswordRequirements: "Пароль должен содержать не менее 8 символов, заглавные и строчные буквы, цифру и специальный символ (!@#$%^&*)",
        AlreadyHaveAccount: "Уже есть учетная запись?",
        LoginHere: "Войдите здесь",
        DontHaveAccount: "Нет учетной записи?",
        RegisterHere: "Зарегистрируйтесь здесь",
        VerifyEmail: "Подтвердить email",
        VerifyEmailDescription: "Введите код подтверждения, отправленный на вашу почту",
        VerificationToken: "Код подтверждения",
        EnterVerificationToken: "Введите код подтверждения",
        TokenFromEmail: "Найдите этот код в вашем письме",
        VerifyButton: "Подтвердить учетную запись",
        VerificationSuccessful: "Email успешно подтвержден! Теперь вы можете войти.",
        VerificationFailed: "Не удалось подтвердить email",
        VerifyingEmail: "Подтверждаем ваш email...",
        GoToLogin: "Перейти к входу",
        DidntReceiveEmail: "Не получили письмо?",
        ResendVerification: "Отправить письмо повторно",
        VerificationEmailResent: "Письмо с подтверждением отправлено повторно. Проверьте почту.",
        RegistrationSuccessMessage: "Регистрация успешна! Проверьте почту для подтверждения учетной записи.",
        RegistrationFailed: "Регистрация не удалась. Пожалуйста, попробуйте еще раз.",
        InvalidEmail: "Пожалуйста, введите действительный адрес электронной почты",
        InvalidPhoneNumber: "Пожалуйста, введите действительный номер телефона",
        PasswordTooShort: "Пароль должен содержать не менее 8 символов",
        PasswordNeedsUppercase: "Пароль должен содержать хотя бы одну заглавную букву",
        PasswordNeedsLowercase: "Пароль должен содержать хотя бы одну строчную букву",
        PasswordNeedsNumber: "Пароль должен содержать хотя бы одну цифру",
        PasswordNeedsSpecialChar: "Пароль должен содержать хотя бы один специальный символ (!@#$%^&*)",
        FirstNameRequired: "Имя обязательно",
        LastNameRequired: "Фамилия обязательна",
        EmailRequired: "Email обязателен",
        EmailAndTokenRequired: "Email и код обязательны",
        ResendFailed: "Не удалось повторно отправить письмо с подтверждением",
        Registration_InvalidEmail: "Пожалуйста, введите действительный адрес электронной почты",
        Registration_EmailAlreadyExists: "Этот email уже зарегистрирован",
        Registration_PasswordRequired: "Пароль обязателен",
        Registration_PasswordTooShort: "Пароль должен содержать не менее 8 символов",
        Registration_PasswordNeedsUppercase: "Пароль должен содержать хотя бы одну заглавную букву",
        Registration_PasswordNeedsLowercase: "Пароль должен содержать хотя бы одну строчную букву",
        Registration_PasswordNeedsNumber: "Пароль должен содержать хотя бы одну цифру",
        Registration_PasswordNeedsSpecialChar: "Пароль должен содержать хотя бы один специальный символ",
        Registration_SystemError: "Системная ошибка. Пожалуйста, попробуйте позже.",
        Registration_Successful: "Регистрация успешна! Проверьте почту для подтверждения.",
        Verification_InvalidToken: "Недействительный код подтверждения",
        Verification_TokenExpired: "Срок действия вашей ссылки для подтверждения истек. Пожалуйста, нажмите 'Отправить письмо подтверждения повторно', чтобы получить новую ссылку.",
        Verification_TokenAlreadyUsed: "Ваш адрес электронной почты уже подтвержден. Теперь вы можете войти в свою учетную запись.",
        Verification_UserNotFound: "Пользователь не найден",
        Verification_SystemError: "Системная ошибка. Пожалуйста, попробуйте позже.",
        Verification_Successful: "Email успешно подтвержден!",
        Verification_AlreadyVerified: "Email уже подтвержден",
        Verification_EmailResent: "Письмо с подтверждением отправлено повторно",
        TooManyAttempts: "Слишком много попыток регистрации. Пожалуйста, попробуйте позже.",
        ForgotPassword: "Забыли пароль?",
        ForgotPasswordInstruction: "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
        BackToLogin: "Вернуться к входу",
        SendResetLink: "Отправить ссылку для сброса"
    },
    deleteDialog: {
        Header: "Подтвердить удаление",
        DeleteMessage: "Вы уверены, что хотите удалить {objectName}?",
        Delete: "Удалить",
        Cancel: "Отмена",
        DeletedSuccessfully: "{objectName} был успешно удален!"
    },
    toast: {
        UserCreated: "Пользователь успешно создан!",
        UserUpdated: "Пользователь успешно обновлен!",
        UserDeleted: "Пользователь успешно удален!",
        FailedToSaveUser: "Не удалось сохранить пользователя!",
        FailedToDeleteUser: "Не удалось удалить пользователя!",
        FailedToLoadUsers: "Не удалось загрузить пользователей!",
        RoleCreated: "Роль успешно создана!",
        RoleUpdated: "Роль успешно обновлена!",
        RoleDeleted: "Роль успешно удалена!",
        FailedToSaveRole: "Не удалось сохранить роль!",
        FailedToDeleteRole: "Не удалось удалить роль!",
        FailedToLoadRoles: "Не удалось загрузить роли!",
        FailedToLoadPrivileges: "Не удалось загрузить привилегии!",
        RoleCodeAndNameRequired: "Код роли и название обязательны!"
    },
    lookup: {
        Name: "Название",
        Code: "Код",
        Type: "Тип",
        LookupDetail: "Детали справочника",
        AddLookup: "Добавить справочник",
        EditLookup: "Редактировать справочник",
        LoadError: "Ошибка загрузки справочников"
    },
    municipality: {
        MunicipalityDetail: "Детали муниципалитета",
        MunicipalityName: "Название муниципалитета",
        MunicipalityCode: "Код муниципалитета",
        AddMunicipality: "Добавить муниципалитет",
        EditMunicipality: "Редактировать муниципалитет",
        DeleteMunicipality: "Удалить муниципалитет",
        Municipality: "Муниципалитет",
        Municipalities: "Муниципалитеты",
        NoMunicipalitiesFound: "Муниципалитеты не найдены",
        MunicipalityNameRequired: "Название муниципалитета обязательно!",
        MunicipalityCodeRequired: "Код муниципалитета обязателен!",
        MunicipalityCodeUnique: "Код муниципалитета должен быть уникальным!",
        MunicipalityDeleted: "Муниципалитет удален",
        DeleteMunicipalityConfirmation: "Вы уверены, что хотите удалить этот муниципалитет? Это действие нельзя отменить."
    },
    document: {
        Documents: "Документы",
        Templates: "Шаблоны",
        DownloadHistory: "История загрузок",
        NoDownloadHistory: "История загрузок не найдена",
        Name: "Имя документа",
        Code: "Код документа",
        DocumentType: "Тип документа",
        FilterByDocumentType: "Фильтр по типу документа",
        File: "Файл",
        CreateDocument: "Создать документ",
        EditDocument: "Редактировать документ",
        CreateTemplate: "Создать шаблон",
        EditTemplate: "Редактировать шаблон",
        AddTemplate: "Добавить шаблон",
        SelectDocumentType: "Выберите тип документа",
        TemplateDocumentTypeInfo: "Шаблоны автоматически устанавливаются как тип документа Шаблон",
        AvailablePlaceholders: "Доступные заполнители",
        PlaceholderUsageInfo: "Используйте эти заполнители в ваших файлах шаблонов. Они будут автоматически заменены фактическими значениями при создании документов.",
        // Placeholder descriptions
        PlaceholderFirstName: "Имя жителя",
        PlaceholderLastName: "Фамилия жителя",
        PlaceholderPersonalCode: "Личный код",
        PlaceholderBirthDate: "Дата рождения",
        PlaceholderContractNumber: "Номер контракта",
        PlaceholderContractStartDate: "Дата начала контракта",
        PlaceholderContractEndDate: "Дата окончания контракта",
        PlaceholderFacilityName: "Название учреждения",
        PlaceholderMunicipalityName: "Название муниципалитета",
        PlaceholderMunicipalityDecisionNr: "Номер решения муниципалитета",
        PlaceholderGuardianName: "Имя опекуна",
        PlaceholderGuardianPhone: "Телефон опекуна",
        PlaceholderGuardianEmail: "Email опекуна",
        PlaceholderResidentAddress: "Адрес жителя",
        PlaceholderServiceType: "Тип услуги",
        PlaceholderMonthlyCost: "Ежемесячная стоимость услуги",
        PlaceholderCreatedDate: "Дата создания контракта",
        PlaceholderCreatedBy: "Кем создан контракт",
        ChooseFile: "Выбрать файл",
        ReplaceFile: "Заменить файл",
        SelectedFile: "Выбранный файл",
        CurrentFileInfo: "Текущий файл - нажмите для загрузки или удалите для удаления",
        DownloadFile: "Скачать файл",
        DeleteFile: "Удалить файл",
        FileMarkedForDeletion: "Файл помечен для удаления. Загрузите новый файл или он будет удален при сохранении.",
        LoadError: "Не удалось загрузить документ",
        SaveError: "Не удалось сохранить документ",
        SaveSuccess: "Документ успешно сохранен",
        DeleteSuccess: "Документ успешно удален",
        DeleteError: "Не удалось удалить документ",
        ConfirmDelete: "Вы уверены, что хотите удалить '{name}'?",
        Download: "Скачать",
        DownloadStarted: "Загрузка началась",
        DownloadError: "Не удалось скачать документ"
    },
    medicalInformation: {
        BasicInformation: "Основная информация",
        MedicalConditions: "Медицинские состояния",
        Mobility: "Подвижность",
        MobilityDescription: "Описание подвижности",
        HealthStatusNotes: "Заметки о состоянии здоровья",
        InfectiousDiseaseNotes: "Заметки об инфекционных заболеваниях",
        IsSmoker: "Курящий",
        IsAlcoholic: "Алкоголик",
        IsDementia: "Деменция",
        IsViolent: "Агрессивный",
        IsDigestionProblem: "Проблемы с пищеварением",
        IsDiabetes: "Диабет",
        IsMentalDisorder: "Психическое расстройство",
        IsSpeechImpairment: "Нарушение речи",
        IsHearingImpairment: "Нарушение слуха",
        IsMRSA: "MRSA",
        IsDialysis: "Диализ",
        IsESBL: "ESBL",
        IsTuberculosis: "Туберкулез",
        SaveSuccess: "Медицинская информация успешно сохранена",
        LoadError: "Не удалось загрузить медицинскую информацию",
        SaveError: "Не удалось сохранить медицинскую информацию"
    },
    observation: {
        Observations: "Наблюдения",
        Observation: "Наблюдение",
        ObservationType: "Тип наблюдения",
        ObservationId: "ID наблюдения",
        Notes: "Заметки",
        ObservationDetails: "Детали наблюдения",
        AddObservation: "Добавить наблюдение",
        EditObservation: "Редактировать наблюдение",
        SelectObservationType: "Выберите тип наблюдения",
        SelectResident: "Выберите жителя",
        NotesPlaceholder: "Введите заметки наблюдения...",
        ObservationTypeRequired: "Тип наблюдения обязателен",
        NotesRequired: "Заметки обязательны",
        ResidentRequired: "Выбор жителя обязателен",
        CreateSuccess: "Наблюдение успешно создано",
        UpdateSuccess: "Наблюдение успешно обновлено",
        SaveError: "Не удалось сохранить наблюдение",
        LoadError: "Не удалось загрузить наблюдение",
        DeleteError: "Не удалось удалить наблюдение",
        NoObservationsFound: "Наблюдения не найдены",
        AddFirstObservation: "Добавить первое наблюдение",
        types: {
            General: "Общий",
            Medical: "Медицинский",
            Behavioral: "Поведенческий",
            Care: "Уход"
        }
    },
    foodMenu: {
        FoodMenu: "Меню питания",
        FoodMenus: "Меню питания",
        AddFoodMenu: "Добавить меню питания",
        EditFoodMenu: "Изменить меню питания",
        FoodMenuDetails: "Детали меню питания",
        BasicInformation: "Основная информация",
        MenuDetails: "Детали меню",
        Menu: "Меню",
        NutritionalInformation: "Пищевая информация",
        MenuDate: "Дата меню",
        MenuPlaceholder: "Введите пункты меню на эту дату...",
        NutritionalInfoPlaceholder: "Введите пищевую информацию (калории, аллергены и т.д.)...",
        SelectDateRangeToStart: "Выберите диапазон дат для начала создания меню",
        SelectDateRange: "Выберите диапазон дат",
        LoadError: "Не удалось загрузить меню питания",
        SaveError: "Не удалось сохранить меню питания",
        DeleteError: "Не удалось удалить меню питания",
        CreateSuccess: "Меню питания успешно создано",
        UpdateSuccess: "Меню питания успешно обновлено",
        DeleteSuccess: "Меню питания успешно удалено",
        SelectResidents: "Выберите жителей",
        AllResidentsSelected: "Все жители выбраны",
        NoFoodMenusFound: "Меню питания не найдены",
        AddFirstFoodMenu: "Добавить первое меню питания",
        MenuRequired: "Меню обязательно",
        MenuDateRequired: "Дата меню обязательна",
        ResidentsRequired: "Необходимо выбрать хотя бы одного жителя",
        StartDateRequired: "Дата начала обязательна",
        EndDateRequired: "Дата окончания обязательна",
        EndDateMustBeAfterStartDate: "Дата окончания должна быть после даты начала",
        SelectAtLeastOneResident: "Пожалуйста, выберите хотя бы одного жителя",
        NoMenuDatesToSave: "Нет дат меню для сохранения",
        AllMenusMustBeFilled: "Все поля меню должны быть заполнены",
        DateRange: "Диапазон дат",
        StartDate: "Дата начала",
        EndDate: "Дата окончания"
    },
    scheduledActivity: {
        ScheduledActivities: "Запланированные мероприятия",
        ScheduledActivity: "Запланированное мероприятие",
        ActivityType: "Тип мероприятия",
        Description: "Описание",
        When: "Когда",
        Resident: "Житель",
        AddScheduledActivity: "Добавить запланированное мероприятие",
        EditScheduledActivity: "Редактировать запланированное мероприятие",
        SelectActivityType: "Выберите тип мероприятия",
        SelectResident: "Выберите жителя",
        DescriptionPlaceholder: "Введите описание мероприятия...",
        ActivityTypeRequired: "Тип мероприятия обязателен",
        DescriptionRequired: "Описание обязательно",
        ResidentRequired: "Выбор жителя обязателен",
        CreateSuccess: "Запланированное мероприятие успешно создано",
        UpdateSuccess: "Запланированное мероприятие успешно обновлено",
        SaveError: "Не удалось сохранить запланированное мероприятие",
        LoadError: "Не удалось загрузить запланированное мероприятие",
        DeleteError: "Не удалось удалить запланированное мероприятие",
        NoItemsFound: "Запланированные мероприятия не найдены",
        AddFirstItem: "Добавить первое запланированное мероприятие"
    },
    invoice: {
        Invoices: "Счета",
        InvoiceDetail: "Данные счета",
        AddInvoice: "Добавить счет",
        EditInvoice: "Редактировать счет",
        InvoiceDetails: "Детали счета",
        SearchByNumber: "Поиск по номеру счета",
        number: "Номер счета",
        numberPlaceholder: "Введите номер счета",
        resident: "Резидент",
        selectResident: "Выберите резидента",
        type: "Тип счета",
        selectType: "Выберите тип счета",
        startDate: "Дата начала",
        selectDate: "Выберите дату",
        dueDate: "Срок оплаты",
        selectDueDate: "Выберите срок оплаты",
        amount: "Сумма",
        amountPlaceholder: "Введите сумму",
        vatIncluded: "НДС включен",
        vatIncludedLabel: "НДС включен в сумму",
        document: "Документ",
        uploadDocument: "Выберите документ",
        viewDocument: "Просмотреть документ",
        InvoiceDocument: "Документ счёта",
        NoDocumentSelected: "Документ не выбран",
        Number: "Номер счета",
        StartDate: "Дата начала",
        DueDate: "Срок оплаты",
        InvoiceType: "Тип счета",
        Amount: "Сумма",
        IsVATIncluded: "НДС включен",
        Document: "Документ",
        CalculationSetup: "Настройка расчета",
        Setup: "Настройка",
        SetupDescription: "Управление настройками расчета и настройками расчета услуг для расчетов счетов.",
        ServiceCalculationSetupDescription: "Настройка тарифов на услуги, базовых ставок и периодов выставления счетов для различных услуг.",
        CalculationSetupDescription: "Настройка констант Excel и ставок поддержки муниципалитета для расчетов счетов.",
        ManageServiceCalculationSetups: "Управление Настройками Расчетов Услуг",
        ManageCalculationSetups: "Управление Настройками Расчетов",
        Download: "Скачать",
        NumberRequired: "Номер счета обязателен",
        StartDateRequired: "Дата начала обязательна",
        DueDateRequired: "Срок оплаты обязателен",
        InvoiceTypeRequired: "Тип счета обязателен",
        AmountRequired: "Сумма должна быть больше 0",
        ResidentRequired: "Житель обязателен",
        DocumentRequired: "Документ обязателен",
        DueDateMustBeAfterStartDate: "Срок оплаты должен быть больше или равен дате начала",
        InvoiceCreated: "Счет успешно создан",
        InvoiceUpdated: "Счет успешно обновлен",
        SaveError: "Не удалось сохранить счет",
        LoadError: "Не удалось загрузить счет",
        DeleteError: "Не удалось удалить счет",
        DownloadError: "Не удалось скачать счет",
        DownloadNotImplemented: "Функция скачивания еще не реализована",
        CalculationSetupNotImplemented: "Настройка расчета еще не реализована",
        UploadNotImplemented: "Функция загрузки еще не реализована",
        NoInvoicesFound: "Счета не найдены",
        AddFirstInvoice: "Добавить первый счет",
        SelectInvoiceType: "Выберите тип счета"
    },
    invoiceCalculation: {
        CalculationDetail: "Детали расчета",
        CalculatedValues: "Расчетные значения",
        StockCostBreakdown: "Разбивка стоимости запасов",
        StockItemsUsed: "Складские позиции, использованные в расчете",
        NoStockItems: "В этом расчете не использовались складские позиции",
        TotalStockCost: "Общая стоимость запасов",
        Article: "Артикул",
        Units: "Единицы",
        CostPerUnit: "Стоимость за единицу",
        TotalCost: "Общая стоимость",
        MovementDate: "Дата перемещения",
        MovementType: "Тип перемещения",
        StockLevel: "Уровень запасов",
        Calculations: "Расчеты",
        InvoiceCalculationWorkflow: "Рабочий процесс расчета счетов",
        WorkflowDescription: "Создание и управление массовыми расчетами счетов для жителей",
        Step1Setup: "Настройка параметров расчета",
        Step2Selection: "Выбор жителей",
        Step3Calculation: "Расчет и проверка",
        Step4Actions: "Финальные действия",
        Step1Description: "Настройка параметров расчета и выбор настройки",
        Step2Description: "Выбор жителей и ввод ручных данных",
        Step3Description: "Просмотр результатов расчета и утверждение",
        Step4Description: "Финальные действия и завершение рабочего процесса",
        CalculationPeriod: "Период расчета",
        SelectPeriod: "Выберите период расчета",
        CalculationSetup: "Настройка расчета",
        SelectSetup: "Выберите настройку расчета",
        SetupRequiredFields: "Пожалуйста, выберите настройку расчета и период для продолжения",
        ProceedToSelection: "Перейти к выбору",
        ResidentsSelected: "Выбрано жителей: {count}",
        ProceedToCalculation: "Перейти к расчету",
        CalculatingInProgress: "Расчет в процессе",
        ProcessingCalculations: "Обработка расчетов...",
        RecalculateAll: "Пересчитать все",
        ProceedToActions: "Перейти к действиям",
        CalculationResults: "Результаты расчета",
        CalculationResultsDescription: "Просмотрите и утвердите результаты расчета",
        TotalCalculations: "Всего расчетов: {count}",
        ApprovedCalculations: "Утверждено: {count}",
        TotalAmount: "Общая сумма: {amount}",
        TotalAmountSum: "Общая сумма: {amount}",
        SpecialCalculations: "Специальный муниципалитет: {count}",
        AverageAmount: "Средняя сумма: {amount}",
        ApproveAllCalculations: "Утвердить все расчеты",
        GenerateInvoices: "Сгенерировать счета",
        ExportToExcel: "Экспорт в Excel",
        StartNewWorkflow: "Начать новый рабочий процесс",
        SelectResidents: "Выберите жителей для расчета",
        SelectResidentsDescription: "Выберите жителей для включения в массовый расчет",
        SelectByMunicipality: "Выбрать по муниципалитету",
        ExcelCalculationBreakdown: "Разбивка расчетов",
        AllColumnsEtoAR: "Все столбцы расчета",
        MaintenanceObligated: "Ответственное лицо",
        CalculationType: "Тип расчета",
        ServicePeriodStartDate: "Начало обслуживания",
        ServicePeriodEndDate: "Конец обслуживания",
        DaysOfMonth: "Дни",
        NursingHomeCareComponent: "Компонент ухода в доме престарелых",
        ServiceFeePerDay: "Расход на уход в день",
        FinalExtraCost: "Дополнительные расходы",
        MunicipalityLimit: "Лимит муниципалитета",
        ResidentBrutoIncome: "Валовой доход",
        ResidentAllowence: "Пособие",
        ResidentOtherResponsibilitiesCost: "Другие расходы",
        BookingDays: "Дни бронирования",
        TimeOffDays: "Выходные дни",
        AverageOldAgePension: "Средняя пенсия по старости",
        ResidentTotalInMonth: "Общая сумма жителя за месяц",
        ThirdPartyTotalInMonth: "Общая сумма третьей стороны за месяц",
        MunicipalityTotalObligations: "Общая сумма обязательств муниципалитета за месяц",
        ExcelE: "Ответственное лицо существует",
        ExcelF: "Тип расчета",
        ExcelG: "Начало периода обслуживания",
        ExcelH: "Конец периода обслуживания",
        ExcelI: "Дни месяца",
        ExcelJ: "Плата за обслуживание в месяц",
        ExcelK: "Стоимость ухода",
        ExcelL: "Дополнительные расходы",
        ExcelN: "Поддержка муниципалитета",
        ExcelO: "Плата за услугу (если > поддержки)",
        ExcelP: "Другие расходы",
        ExcelQ: "Доход жителя",
        ExcelS: "Валовой доход жителя",
        ExcelT: "Пособие жителя",
        ExcelU: "Другие обязательства жителя",
        ExcelV: "Расходы жителя до поддержки",
        ExcelW: "Остаток пособия жителя",
        ExcelZ: "Необходимые дополнительные деньги",
        ExcelAA: "Компенсация низкого дохода",
        ExcelAB: "Максимальные расходы на содержание (Таллинн)",
        ExcelAE: "Дополнительная компенсация для иждивенцев",
        ExcelAF: "Общая сумма жителя в месяц",
        ExcelAG: "Общая сумма третьей стороны в месяц",
        ExcelAH: "Сводка обязательств муниципалитета",
        ExcelAQ: "Общий счет без пособия",
        ExcelAR: "Контрольный столбец",
        Special: "Специальный",
        Standard: "Стандартный",
        ViewBreakdown: "Просмотреть разбивку",
        ResidentTotal: "Всего житель",
        ThirdParty: "Третья сторона",
        Municipality: "Муниципалитет",
        TotalBill: "Общий счет",
        Recalculate: "Пересчитать",
        NoCalculationsYet: "Расчетов пока нет",
        SelectResidentsToCalculate: "Выберите жителей для начала расчета",
        LoadingSetupsError: "Ошибка загрузки настроек расчета",
        CalculationsCompleted: "Расчеты успешно завершены",
        CalculationsPartiallyCompleted: "Расчеты частично завершены",
        NoCalculationsCompleted: "Расчеты не завершены",
        CalculationError: "Ошибка при расчете",
        RecalculationError: "Ошибка при пересчете",
        ApprovalSuccess: "Расчеты успешно утверждены",
        UnapprovalSuccess: "Утверждение успешно отменено",
        ApprovalError: "Ошибка при утверждении расчетов",
        InvoiceGenerationNotImplemented: "Генерация счетов еще не реализована",
        ExcelExportNotImplemented: "Экспорт в Excel еще не реализован",
        NoCalculationsToExport: "Нет расчетов для экспорта",
        NoCalculationLoaded: "Расчет не загружен",
        ExcelExportSuccess: "Расчеты успешно экспортированы в Excel",
        WorkflowReset: "Рабочий процесс сброшен",
        CalculationBreakdown: "Разбивка расчета",
        BreakdownIntro: "Детальный обзор того, как вычислено каждое поле, в соответствии со столбцами Excel.",
        ExtraCost: "Дополнительные расходы",
        ServiceFeeForFacility: "Расход на уход (K)",
        CareCostHelp: "Стоимость ухода за период (Excel K). Берется из настройки расчета услуг; при необходимости можно скорректировать.",
        CareCostFromContract: "Стоимость ухода настроена в муниципальном договоре резидента",
        NotSet: "Не установлено",
        PlaceFeeOverride: "Ежемесячная плата за место (J), переопределение",
        PlaceFeeOverrideHelp: "Необязательное переопределение ежемесячной платы за место (Excel J). Оставьте пустым, чтобы использовать значение из настройки расчета.",
        OtherResponsibilities: "Другие обязательства",
        LessDaysComment: "Комментарий о меньшем количестве дней",
        LessDaysCommentPlaceholder: "Введите комментарий для уменьшенных дней...",
        GeneralComment: "Общий комментарий",
        GeneralCommentPlaceholder: "Введите общий комментарий...",
        ReadyForCalculation: "Готов к расчету",
        MissingRequiredData: "Отсутствуют обязательные данные",
        ValidationIssues: "Проблемы валидации",
        NoResidentsSelected: "Жители не выбраны",
        IncompleteResidents: "{count} жителей имеют неполные данные",
        ResidentsProcessed: "Обработанные жители",
        CalculatedValue: "Вычислено",
        Calculated: "Вычислено",
        EditExtraCost: "Редактировать доп. расходы",
        CalculatedStockCost: "Вычисленная стоимость запасов",
        AutomaticStockCalculation: "Автоматически вычислено из движений запасов в выбранном периоде",
        ManualOverride: "Ручное переопределение",
        EnterManualOverride: "Введите сумму ручного переопределения...",
        ManualOverrideDescription: "Оставьте пустым для использования вычисленной стоимости запасов",
        EffectiveValue: "Эффективное значение",
        UsingManualOverride: "Используется ручное переопределенное значение",
        UsingCalculatedValue: "Используется вычисленная стоимость запасов",
        ClearOverride: "Очистить переопределение",
        ExtraCostUpdated: "Дополнительные расходы успешно обновлены",
        ExtraCostUpdateError: "Ошибка при обновлении дополнительных расходов",
        AdjustExtraCost: "Корректировать дополнительные расходы",
        AdjustmentAmount: "Сумма корректировки",
        EnterAdjustmentAmount: "Введите сумму корректировки (положительную или отрицательную)...",
        AdjustmentAmountHelp: "Положительные значения добавляют расходы, отрицательные предоставляют скидку. Ноль или пусто удаляет корректировку.",
        AdjustmentNote: "Примечание корректировки",
        EnterAdjustmentNote: "Введите причину корректировки (обязательно)...",
        CalculatedCost: "Вычисленная стоимость запасов",
        Adjustment: "Корректировка",
        FinalCost: "Итоговые дополнительные расходы",
        AdjustmentSaved: "Корректировка успешно сохранена",
        AdjustmentSaveError: "Ошибка при сохранении корректировки",
        AdjustedBy: "Скорректировано пользователем",
        AdjustedAt: "Скорректировано",
        AdjustmentApplied: "Корректировка применена к расчету",
        // New keys for Calculation List View
        CalculationHistory: "История расчетов",
        CreateNewCalculation: "Создать новый расчет",
        ApprovedLocked: "Утвержден (заблокирован)",
        NotApproved: "Не утвержден",
        Approved: "Утвержден",
        ViewCalculation: "Просмотреть расчет",
        DeleteCalculation: "Удалить расчет",
        ConfirmDeleteCalculation: "Вы уверены, что хотите удалить этот расчет?",
        DeleteCalculationSuccess: "Расчет успешно удален",
        DeleteCalculationError: "Ошибка при удалении расчета",
        // Stock Movement Conflict Detection
        StockMovementConflictDetected: "Конфликт с другим расчетом счета",
        ConflictWarning: "Этот расчет использует движения товаров, которые уже назначены другому утвержденному расчету.",
        ConflictDescription: "{count} движени(й/я) товаров конфликтует с утвержденными расчетами: {calculationIds}",
        ConflictDescriptionShort: "{count} движени(й/я) товаров конфликтует с утвержденными расчетами",
        MustRecalculate: "Для разрешения конфликтов необходимо пересчитать расчет перед утверждением.",
        ConflictedMovements: "Конфликтующие движения товаров",
        ConflictingCalculations: "Конфликтующие расчеты",
        RecalculateToResolve: "Пересчитать для разрешения",
        CannotApproveWithConflicts: "Невозможно утвердить расчет с конфликтами движений товаров",
        RecalculateSuccess: "Расчет успешно пересчитан",
        RecalculateFailed: "Ошибка пересчета расчета",
        ApproveSuccess: "Расчет успешно утвержден",
        ApproveFailed: "Ошибка утверждения расчета",
        UnapproveSuccess: "Утверждение расчета успешно отменено",
        UnapproveFailed: "Ошибка отмены утверждения расчета",
        CalculationCreatedSuccess: "Расчет успешно создан",
        Calculation: "Расчет",
        PeriodStart: "Начало периода",
        PeriodEnd: "Конец периода",
        BulkRecalculate: "Пересчитать",
        BulkDelete: "Удалить",
        BulkApprove: "Утвердить",
        BulkExport: "Экспорт в Excel",
        BulkRecalculateSuccess: "{count} расчет(ов) успешно пересчитаны",
        BulkRecalculateFailed: "Ошибка пересчета расчетов",
        BulkDeleteSuccess: "{count} расчет(ов) успешно удалены",
        BulkDeleteFailed: "Ошибка удаления расчетов",
        BulkDeleteConfirm: "Вы уверены, что хотите удалить {count} расчет(ов)?",
        BulkDeleteApprovedWarning: "Невозможно удалить утвержденные расчеты. {count} утвержденных расчет(ов) будут пропущены.",
        BulkApproveSuccess: "{successCount} расчет(ов) успешно утверждены",
        BulkApprovePartial: "{successCount} утверждены, {failedCount} не удалось из-за конфликтов или других ошибок",
        BulkApprovePartialFail: "{success} утверждены, {failed} не удалось из-за конфликтов или других ошибок",
        BulkApproveFailed: "Ошибка утверждения расчетов",
        SomeApprovedSkipped: "Некоторые утвержденные расчеты были пропущены",
        SomeAlreadyApprovedSkipped: "Некоторые расчеты уже утверждены и были пропущены",
        AllAlreadyApproved: "Все выбранные расчеты уже утверждены",
        BulkExportSuccess: "Файл Excel успешно создан",
        BulkExportFailed: "Ошибка создания файла Excel",
        BulkExportNotImplemented: "Функция экспорта в Excel еще не реализована. Эта функция требует установки библиотеки генерации Excel.",
        SelectedCalculations: "{count} расчет(ов) выбрано",
        DuplicateSelectionWarning: "Дублирующий расчет для того же жителя и периода",
        CannotApproveDuplicates: "Невозможно утвердить: выбраны дублирующие расчеты для одного жителя и периода",
        ApprovedCalculationWarning: "Утвержденный расчет не может быть пересчитан",
        CannotRecalculateApproved: "Невозможно пересчитать: выбраны утвержденные расчеты",
        CannotDeleteApproved: "Невозможно удалить: выбраны утвержденные расчеты"
    },
    calculationSetup: {
        CalculationSetups: "Настройки расчета",
        ManageCalculationSetups: "Управление настройками расчета",
        ManageSetups: "Управление настройками",
        CreateSetup: "Создать настройку расчета",
        EditSetup: "Редактировать настройку расчета",
        BasicInformation: "Основная информация",
        ExcelConstants: "Константы Excel (из ссылок Excel)",
        NamePlaceholder: "Введите название настройки (например, Летние тарифы 2024)",
        DescriptionPlaceholder: "Введите описание (необязательно)",
        MunicipalitySupportPerResident: "Поддержка муниципалитета на жителя",
        Support1: "Уровень поддержки 1 ($I$7)",
        Support2: "Уровень поддержки 2 ($I$8)",
        Support3: "Уровень поддержки 3 ($I$9)",
        Preview: "Предварительный просмотр",
        MunicipalitySupport: "Поддержка муниципалитета",
        Constants: "Константы",
        UsageCount: "Количество использований",
        Duplicate: "Дублировать",
        SearchByName: "Поиск настроек расчета по названию",
        NameRequired: "Название обязательно",
        ReportPeriodRequired: "Дни отчетного периода обязательны",
        Support1Required: "Уровень поддержки 1 обязателен",
        Support2Required: "Уровень поддержки 2 обязателен",
        Support3Required: "Уровень поддержки 3 обязателен",
        CreatedSuccessfully: "Настройка расчета успешно создана",
        UpdatedSuccessfully: "Настройка расчета успешно обновлена",
        DuplicatedSuccessfully: "Настройка расчета успешно дублирована",
        CreateError: "Ошибка создания настройки расчета",
        UpdateError: "Ошибка обновления настройки расчета",
        DuplicationError: "Ошибка дублирования настройки расчета",
        DeleteError: "Ошибка удаления настройки расчета",
        LoadingError: "Ошибка загрузки настроек расчета"
    },
    serviceCalculationSetup: {
        ServiceCalculationSetups: "Настройки Расчетов Услуг",
        ManageServiceCalculationSetups: "Управление Настройками Расчетов Услуг",
        CreateServiceCalculationSetup: "Создать Настройку Расчетов Услуг",
        EditServiceCalculationSetup: "Редактировать Настройку Расчетов Услуг",
        BaseFee: "Базовая Плата",
        Period: "Период",
        SelectPeriod: "Выберите Период",
        BookingPercentage: "Процент бронирования",
        TimeOffDailyRate: "Дневная ставка отгула",
        SearchByName: "Поиск по имени",
        SearchByCode: "Поиск по коду",
        NameRequired: "Имя обязательно",
        CodeRequired: "Код обязателен",
        BaseFeeRequired: "Базовая плата обязательна",
        PeriodRequired: "Период обязателен"
    },
    residentContractDocument: {
        ContractDocuments: "Документы контрактов",
        CreateContractDocument: "Создать документ контракта",
        EditContractDocument: "Редактировать документ контракта",
        ContractType: "Тип контракта",
        ContractId: "ID контракта",
        Document: "Документ",
        DocumentType: "Тип документа",
        IsActive: "Активен",
        Version: "Версия",
        SetActive: "Установить активным",
        DocumentSetActive: "Документ установлен как активный"
    },
    stock: {
        Stock: "Запасы",
        Articles: "Товары",
        Article: "Товар",
        ArticleName: "Название товара",
        ArticleCode: "Код товара",
        ArticleType: "Тип товара",
        EditArticle: "Редактировать товар",
        Manufacturer: "Производитель",
        Unit: "Единица измерения",
        PackageType: "Тип упаковки",
        ActiveIngredient: "Активное вещество",
        Strength: "Крепость",
        Description: "Описание",
        StandardCost: "Стандартная стоимость",
        RequiresPrescription: "Требует рецепта",
        IsControlledSubstance: "Контролируемое вещество",
        StorageConditions: "Условия хранения",
        BasicInformation: "Основная информация",
        Inventory: "Запасы",
        StockLevels: "Уровни запасов",
        StockLevel: "Уровень запасов",
        CreateLevel: "Создать уровень",
        EditLevel: "Редактировать уровень",
        AddLevel: "Добавить уровень",
        LevelDetail: "Детали уровня",
        CreateStockLevel: "Создать уровень запасов",
        EditStockLevel: "Редактировать уровень запасов",
        NewStockLevel: "Новый уровень запасов",
        EnterLevelName: "Введите название уровня",
        EnterLevelCode: "Введите код уровня",
        EnterLevelDescription: "Введите описание уровня",
        Level: "Уровень",
        Assignments: "Назначения",
        Items: "Предметы",
        StockItems: "Товары склада",
        AddItem: "Добавить товар",
        AddStockItem: "Добавить товар склада",
        EditStockItem: "Редактировать товар склада",
        NoItemsInLevel: "В этом уровне запасов нет товаров",
        SearchByStockLevel: "Поиск по уровню склада",
        StockLevelFilter: "Фильтр уровня склада",
        NoStockLevelsFound: "Уровни склада не найдены",
        AddFirstItem: "Нажмите 'Добавить товар', чтобы добавить первый товар склада",
        ViewStockLevel: "Просмотр уровня запасов",
        Movements: "Движения",
        StockMovements: "Движения запасов",
        AddMovement: "Добавить движение",
        MovementType: "Тип движения",
        StockItem: "Товар склада",
        Units: "Единицы",
        Pieces: "Штуки",
        Date: "Дата",
        Reports: "Отчеты",
        Location: "Местоположение",
        Quantity: "Количество",
        CurrentQuantity: "Текущее количество",
        PieceQuantity: "Количество штук",
        OpenedQuantity: "Количество штук в открытой единице",
        MinimumLevel: "Минимальный уровень",
        MaximumLevel: "Максимальный уровень",
        ReorderPoint: "Точка дозаказа",
        ReorderQuantity: "Количество дозаказа",
        BatchNumber: "Номер партии",
        ExpiryDate: "Срок годности",
        PackageOpenDate: "Дата вскрытия единицы",
        LastMovement: "Последнее движение",
        BatchLabel: "Партия",
        ExpiryLabel: "Истеч",
        NotAvailable: "Нет",
        Min: "Мин",
        Max: "Макс",
        Batch: "Партия",
        Expires: "Истекает",
        MinMaxLevels: "Мин/Макс уровни",
        BatchExpiry: "Партия/Истечение",
        StockArticle: "Товар склада",
        SelectArticle: "Выберите товар",
        SelectResidents: "Выберите жителя",
        SelectStockLevels: "Выберите уровень запасов",
        SelectStockLevel: "Выберите уровень запасов",
        FromStockLevel: "С уровня запасов",
        ToStockLevel: "На уровень запасов",
        FromLevel: "С уровня",
        ToLevel: "На уровень",
        Note: "Примечание",
        SelectDestinationLevel: "Выберите целевой уровень",
        SelectLevelWithStock: "Выберите уровень запасов с доступными товарами (количество > 0)",
        AvailableArticles: "Доступные товары",
        SelectedArticle: "Выбранный товар",
        StockItemDetails: "Детали товара склада",
        StockItemDetail: "Детали товара склада",
        PleaseSelectArticle: "Пожалуйста, выберите товар для продолжения",
        NoArticlesFound: "Товары не найдены",
        TryDifferentSearch: "Попробуйте изменить поисковые термины или фильтры",
        AllResidents: "Все жители",
        Resident: "Житель",
        Cost: "Стоимость",
        Dashboard: "Панель управления",
        Code: "Код",
        EnterLocation: "Введите местоположение",
        EnterQuantity: "Введите количество",
        EnterPackageQuantity: "Введите количество единиц",
        UnitsSuffix: "ед.",
        PiecesSuffix: "шт.",
        PackagesSuffix: "ед.",
        EnterMinLevel: "Введите минимальный уровень",
        FullPackagesCount: "Полные, нераспечатанные единицы (контейнеры)",
        LoosePiecesFromOpenedUnits: "Отдельные штуки из открытых единиц",
        PiecesPerUnit: "Штук в единице",
        TotalPieces: "Всего штук",
        TotalUnits: "Всего единиц",
        TotalPurchaseValue: "Общая стоимость покупки",
        CostPerPiece: "Стоимость за штуку",
        CostPerUnit: "Стоимость за единицу",
        StockValue: "Стоимость склада",
        WillBeNormalizedTo: "Будет нормализовано до",
        EnterMaxLevel: "Введите максимальный уровень",
        EnterReorderPoint: "Введите точку дозаказа",
        EnterReorderQuantity: "Введите количество дозаказа",
        EnterBatchNumber: "Введите номер партии",
        SelectExpiryDate: "Выберите срок годности",
        ReorderPointHelp: "Уровень количества, который запускает предупреждение о дозаказе",
        ReorderQuantityHelp: "Рекомендуемое количество для заказа",
        SearchByArticleOrLocation: "Поиск по названию товара, коду или местоположению",
        FilterByArticle: "Фильтр по товару",
        FilterByStockStatus: "Фильтр по статусу запасов",
        FilterByMainLevel: "Фильтр по основному уровню",
        AllStock: "Все запасы",
        InStock: "В наличии",
        LowStock: "Мало на складе",
        OutOfStock: "Нет в наличии",
        ShowAllStock: "Показать все запасы",
        ShowLowStockOnly: "Показать только низкие запасы",
        ShowAllLevels: "Показать все уровни",
        ShowLowStockLevels: "Показать низкие запасы",
        LevelType: "Тип уровня",
        IsMainLevel: "Основной уровень?",
        MainLevel: "Основной уровень",
        SubLevel: "Подуровень",
        MainLevels: "Основные уровни",
        SubLevels: "Подуровни",
        TotalItems: "Всего предметов",
        StockDashboard: "Панель склада",
        TotalStockValue: "Общая стоимость склада",
        InventoryValue: "Стоимость запасов",
        LowStockItems: "Товары с низким запасом",
        ItemsBelowMinimum: "Товары ниже минимума",
        ExpiredItems: "Просроченные товары",
        RequireAttention: "Требуют внимания",
        ActiveItems: "Активные товары",
        StockValueTrend: "Тренд стоимости склада",
        StockValueByLocation: "Стоимость склада по местоположению",
        InvoicedVsNonInvoiced: "Оплаченные vs неоплаченные товары",
        Invoiced: "Оплачено",
        NotInvoiced: "Не оплачено",
        TopArticlesByValue: "Топ товаров по стоимости",
        Value: "Стоимость",
        LowStockArticles: "Товары с низким запасом",
        ExpiringItems: "Истекающие предметы",
        AllLevels: "Все уровни",
        WithLowStock: "С низким запасом",
        NoLowStock: "Без низкого запаса",
        WithExpiringItems: "С истекающими предметами",
        Expiring: "Истекает",
        StockLevelCreated: "Уровень запасов успешно создан",
        StockLevelUpdated: "Уровень запасов успешно обновлен",
        AssignmentDeletedSuccess: "Назначение успешно удалено",
        ErrorLoadingArticles: "Ошибка загрузки товаров склада",
        ErrorLoadingStockLevel: "Ошибка загрузки уровня запасов",
        AddStockArticle: "Добавить Товар",
        StockArticleCreated: "Товар склада успешно создан"
        ,
        // Stock movement translations
        RecordMovement: "Зарегистрировать движение",
        QuickRecordDescription: "Быстро регистрируйте движения запасов, корректировки и переводы",
        RefReason: "Ссылка / Причина",
        LoadMovementsError: "Не удалось загрузить движения",
        MovementRecorded: "Движение успешно зарегистрировано",
        RecordMovementError: "Не удалось зарегистрировать движение",
        Reason: "Причина",
        Available: "Доступно",
        AvailableUnits: "Доступные единицы",
        UnitsAvailable: "{count} единиц доступно",
        ExceedsAvailable: "Превышает доступное количество ({available})",
        PurchaseCostPerUnit: "Закупочная цена за единицу",
        EnterPurchaseCost: "Введите закупочную цену за единицу",
        PurchaseCostDescription: "Фактическая цена, уплаченная за эту конкретную партию/лот. Используется для точных расчетов счетов.",
        BulkAddItems: "Массовое добавление товаров",
        BulkItemsAdded: "Товары успешно добавлены на склад",
        BulkItemsAddError: "Не удалось добавить товары на склад",
        SelectResidentStockLevel: "Выберите уровень запасов жителя для добавления товаров",
        PackageQuantity: "Количество упаковок"
    },
    stockLevel: {
        AssignmentDetailHeader: "Назначение уровня запасов"
    },
    dashboard: {
        Welcome: "Добро пожаловать в Akersoni teenused",
        BookingManagementSystem: "Система управления бронированием терапии",
        TodayBookings: "Сегодняшние бронирования",
        ConfirmedBookings: "Подтверждено",
        TotalClients: "Всего клиентов",
        ActiveServices: "Активные услуги",
        QuickActions: "Быстрые действия",
        MyBookings: "Мои бронирования",
        ViewAndManageYourBookings: "Просмотр и управление вашими бронированиями",
        UpcomingBookings: "Предстоящие бронирования",
        YourNext10Bookings: "Ваши следующие 10 бронирований",
        NoUpcomingBookings: "Нет предстоящих бронирований",
        WelcomeToDashboard: "Добро пожаловать в панель управления дома престарелых Linda",
        OverviewOfOperations: "Быстрый обзор операций вашего дома престарелых и ключевых показателей.",
        UrgentAlerts: "Срочные уведомления",
        NoUrgentAlerts: "В настоящее время нет срочных уведомлений",
        KeyMetrics: "Ключевые показатели",
        RecentActivity: "Последняя активность",
        NoRecentActivity: "Нет последней активности",
        TotalResidents: "Всего жителей",
        ResidentsToday: "Жителей сегодня",
        ActiveAlerts: "Активные уведомления",
        PendingDocuments: "Ожидающие документы",
        PendingTasks: "Ожидающие задачи",
        UpcomingMedicalCheckups: "Предстоящие медицинские осмотры",
        LowStockItems: "Товары с низким запасом",
        MonthlyOccupancyRate: "Ежемесячный коэффициент заполняемости",
        TodaysObservations: "Сегодняшние наблюдения",
        ObservationsToday: "Наблюдений сегодня",
        DocumentsUploaded: "Загруженные документы",
        StockMovements: "Движения запасов",
        AddObservation: "Добавить наблюдение",
        AddObservationDesc: "Записать новые медицинские наблюдения и заметки",
        UploadDocument: "Загрузить документ",
        UploadDocumentDesc: "Загрузить и управлять документами жителей",
        AddResident: "Добавить жителя",
        AddResidentDesc: "Зарегистрировать новых жителей дома престарелых",
        RecordMovement: "Зарегистрировать движение",
        RecordMovementDesc: "Отслеживать движения запасов и изменения инвентаря",
        AlertMedicationExpiring: "Лекарства скоро истекают",
        AlertMedicationExpiringDesc: "{count} лекарств истекают в течение 7 дней",
        MedicationsExpiringSoon: "Лекарства скоро истекают",
        MedicationsExpireWithin7Days: "{count} лекарств истекают в течение 7 дней",
        ContractsExpiring: "Истекающие контракты",
        ContractsExpiringDesc: "{count} контрактов по уходу требуют продления",
        AlertMedicalCheckup: "Медицинские осмотры",
        AlertMedicalCheckupDesc: "У {count} жителей назначены медицинские осмотры",
        AlertContractExpiring: "Истекающий контракт",
        AlertContractExpiringDesc: "Контракт по уходу требует продления",
        ViewDetails: "Просмотр подробностей",
        LastUpdated: "Последнее обновление",
        ActivityObservation: "Новое наблюдение записано для {resident}",
        ActivityStock: "{item} выдано {resident}",
        ActivityDocument: "Документ загружен для {resident}",

        // Activity Log
        RecentActivitiesTitle: "Недавние действия",
        LoadingActivities: "Загрузка действий...",
        NoActivitiesFound: "Действия не найдены",
        ViewAll: "Просмотреть все",
        Collapse: "Свернуть",
        ActivityType: "Тип активности",
        JustNow: "Только что",
        MinutesAgo: "{count} минут назад",
        HoursAgo: "{count} часов назад",
        DaysAgo: "{count} дней назад",
        WeeksAgo: "{count} недель назад",

        // Activity Types
        ActivityResidentCreated: "Зарегистрирован новый резидент",
        ActivityResidentUpdated: "Обновлена информация о резиденте",
        ActivityResidentDeleted: "Резидент удален",
        ActivityObservationCreated: "Записано новое наблюдение",
        ActivityObservationUpdated: "Наблюдение обновлено",
        ActivityObservationDeleted: "Наблюдение удалено",
        ActivityDocumentUploaded: "Документ загружен",
        ActivityDocumentDeleted: "Документ удален",
        ActivityUserCreated: "Создан новый пользователь",
        ActivityUserUpdated: "Пользователь обновлен",
        ActivityUserDeleted: "Пользователь удален",
        ActivityGuardianCreated: "Опекун добавлен",
        ActivityGuardianUpdated: "Опекун обновлен",
        ActivityGuardianDeleted: "Опекун удален",
        ActivityContractCreated: "Контракт создан",
        ActivityContractUpdated: "Контракт обновлен",
        ActivityContractDeleted: "Контракт удален",
        ContractRestoredDesc: "Контракт {contractName} #{contractNumber} восстановлен",
        ResidentRestoredWithContractsDesc: "Резидент {residentName} восстановлен с {contractCount} контрактом(-ами)",
        ActivityStockDispensed: "Товар выдан",
        ActivityStockReceived: "Товар получен",

        // Entity Types
        EntityResident: "Резидент",
        EntityObservation: "Наблюдение",
        EntityDocument: "Документ",
        EntityStock: "Товар",
        EntityContract: "Контракт",
        EntityUser: "Пользователь",
        EntityGuardian: "Опекун",

        // Activity Description Templates (for AdditionalData translation)
        StockTransferredDesc: "Перемещено {quantity} единиц(ы) из {fromLocation} в {toLocation}",
        StockReceivedDesc: "Получено {quantity} единиц(ы) в {location}",
        StockDispensedDesc: "Выдано {quantity} единиц(ы) из {location}",
        StockAdjustedDesc: "Скорректировано {quantity} единиц(ы) в {location}",
        ObservationCreatedDesc: "Создано наблюдение для резидента ID {residentId}",
        ObservationUpdatedDesc: "Обновлено наблюдение для резидента ID {residentId}",
        ObservationDeletedDesc: "Удалено наблюдение для резидента ID {residentId}",
        ResidentCreatedDesc: "Зарегистрирован новый резидент: {firstName} {lastName}",
        ResidentUpdatedDesc: "Обновлен резидент {firstName} {lastName}: {changedFields}",
        ResidentDeletedDesc: "Удален резидент: {firstName} {lastName}",
        DocumentUploadedDesc: "Загружен документ: {documentName}",
        DocumentDeletedDesc: "Удален документ: {documentName}",
        GuardianCreatedDesc: "Добавлен опекун: {guardianName}",
        GuardianUpdatedDesc: "Обновлен опекун: {guardianName}",
        GuardianDeletedDesc: "Удален опекун: {guardianName}",
        ContractCreatedDesc: "Создан контракт для резидента",
        ContractUpdatedDesc: "Контракт обновлен для резидента",
        ContractDeletedDesc: "Контракт удален: {contractName}",
        UserCreatedDesc: "Создан новый пользователь: {username}",
        UserUpdatedDesc: "Обновлен пользователь: {username}",
        UserDeletedDesc: "Удален пользователь: {username}",
        FoodMenuCreatedDesc: "Создано меню питания для {residentCount} резидента(ов)",
        FoodMenuUpdatedDesc: "Обновлено меню питания для {residentCount} резидента(ов)",
        FoodMenuDeletedDesc: "Удалено меню питания для {residentCount} резидента(ов)",
        ScheduledActivityCreatedDesc: "Создана запланированная активность для {residentName}",
        ScheduledActivityUpdatedDesc: "Обновлена запланированная активность для {residentName}",
        ScheduledActivityDeletedDesc: "Удалена запланированная активность для {residentName}"
    },
    booking: {
        CreateBooking: "Создать бронирование",
        ViewBookings: "Просмотр бронирований",
        ManageBookings: "Управление бронированиями",
        Bookings: "Бронирования",
        CalendarTitle: "Календарь бронирования",
        Calendar: "Календарь",
        EditBooking: "Редактировать бронирование",
        BookingSaved: "Бронирование успешно сохранено",
        SaveFailed: "Не удалось сохранить бронирование",
        Client: "Клиент",
        Service: "Услуга",
        Employee: "Сотрудник",
        Room: "Комната",
        Status: "Статус",
        StartDate: "Дата начала",
        EndDate: "Дата окончания",
        StartDateTime: "Дата/время начала",
        EndDateTime: "Дата/время окончания",
        BookingTime: "Время бронирования",
        Participants: "Участники",
        Notes: "Примечания",
        InternalComment: "Внутренний комментарий",
        CancellationReason: "Причина отмены",
        ConflictDetected: "Обнаружен конфликт",
        ConflictEmployeeBooked: "Сотрудник уже занят в это время",
        ConflictRoomOccupied: "Комната уже занята в это время",
        ConflictTimeUnavailable: "Выбранное время недоступно",
        ConflictCapacityExceeded: "Превышена максимальная вместимость услуги",
        PublicHolidayDayOff: "Выбранное время попадает на государственный праздник, отмеченный как выходной день",
        ConflictGeneric: "Обнаружен конфликт бронирования",
        ClearConflict: "Закрыть",
        Templates: "Шаблоны",
        SlotsRemaining: "мест свободно",
        ParticipantsFilled: "участников заполнено",
        Full: "Полный",
        MaxCapacityReached: "Достигнута максимальная вместимость",
        Selected: "выбрано",
        PreHoldExpiring: "Предварительное бронирование истекает",
        Expired: "Истекло",
        Remaining: "осталось",
        SelectClient: "Выберите клиента",
        SelectService: "Выберите услугу",
        SelectEmployee: "Выберите сотрудника",
        SelectRoom: "Выберите комнату",
        BookingStatus: "Статус бронирования",
        SelectStatus: "Выберите статус",
        SelectParticipants: "Выберите участников",
        SelectCancellationReason: "Выберите причину отмены",
        EnterNotes: "Введите примечания",
        EnterInternalComment: "Введите внутренний комментарий",
        DropBookingsHere: "Перетащите бронирования сюда",
        NoService: "Нет услуги",
        NoEmployee: "Нет сотрудника",
        NoStatus: "Нет статуса",
        SpecialClient: "Особый клиент",
        FilterByEmployee: "Фильтр по сотруднику",
        AllEmployees: "Все сотрудники",
        AllStatuses: "Все статусы",
        WeekView: "Неделя",
        DayView: "День",
        Today: "Сегодня",
        Week: "Неделя",
        Day: "День",
        ShowTemplates: "Показать шаблоны",
        HideTemplates: "Скрыть шаблоны",
        StatusPreHold: "Предварительное",
        StatusConfirmed: "Подтверждено",
        StatusCompleted: "Завершено",
        StatusCancelled: "Отменено",
        StatusWaitlisted: "В листе ожидания",
        BookingDetails: "Детали бронирования",
        CreateNewBooking: "Создать новое бронирование",
        SelectedTime: "Выбранное время",
        FormComingSoon: "Форма бронирования скоро появится",
        Updated: "Бронирование успешно обновлено",
        UpdateFailed: "Не удалось обновить бронирование",
        ExpiresIn: "Истекает через",
        ServiceInformation: "Информация об услуге",
        DateTime: "Дата и время",
        LeadClient: "Основной клиент",
        NotFound: "Бронирование не найдено",
        CancelBooking: "Отменить бронирование",
        CancelConfirmation: "Вы уверены, что хотите отменить это бронирование?",
        SelectReason: "Выберите причину",
        CancellationNotesPlaceholder: "Дополнительные примечания об отмене...",
        Approve: "Одобрить",
        ApproveFallback: "Одобрить",
        Reject: "Отклонить",
        RejectFallback: "Отклонить",
        BookingApproved: "Бронирование успешно одобрено",
        ApproveFailed: "Не удалось одобрить бронирование",
        BookingRejected: "Бронирование успешно отклонено",
        RejectFailed: "Не удалось отклонить бронирование",
        Confirmed: "Бронирование успешно подтверждено",
        ConfirmFailed: "Не удалось подтвердить бронирование",
        Cancelled: "Бронирование успешно отменено",
        CancelFailed: "Не удалось отменить бронирование",
        LoadFailed: "Не удалось загрузить бронирование",
        LoadBookingsFailed: "Не удалось загрузить бронирования",
        CreatedSuccessfully: "Бронирование успешно создано",
        CreateFailed: "Не удалось создать бронирование",
        SendNotificationPrompt: "Хотите ли вы отправить email уведомление основному клиенту?",
        SendNotification: "Отправить уведомление",
        ConfirmSendNotification: "Отправить уведомление о бронировании этому клиенту?",
        DontSendNotification: "Не отправлять",
        LeadClientNoUser: "Внимание: У основного клиента нет учетной записи пользователя, и он не может получать email уведомления.",
        EmployeeConflict: "Сотрудник уже занят в это время. Пожалуйста, выберите другое время или сотрудника.",
        RoomConflict: "Комната уже занята в это время. Пожалуйста, выберите другое время или комнату.",
        ClientConflict: "Один или несколько клиентов уже имеют конфликтующие бронирования в это время. Пожалуйста, выберите другое время.",
        MissingSkills: "Отсутствуют необходимые навыки",
        StartTime: "Время начала",
        EndTime: "Время окончания",
        EndsAt: "Заканчивается в",
        AdditionalParticipants: "Дополнительные участники",
        SelectAdditionalClients: "Выберите дополнительных клиентов",
        ParticipantsSingular: "участник",
        ParticipantsPlural: "участников",
        NoClientRequired: "Клиент не требуется",
        NoClientRequiredTooltip: "Отметьте это для консультаций или обзоров с потенциальными клиентами, еще не зарегистрированными в системе",
        CapacityAvailable: "{count} мест доступно",
        IndividualServiceOneParticipant: "Индивидуальная услуга - разрешен только 1 участник",
        CapacityExceeded: "Превышена вместимость - разрешено максимум {max} участников",
        "Conflict.EMPLOYEE_BOOKED": "Сотрудник уже занят в это время",
        "Conflict.ROOM_OCCUPIED": "Комната уже занята в это время",
        "Conflict.TIME_UNAVAILABLE": "Выбранное время недоступно",
        "Conflict.CAPACITY_EXCEEDED": "Превышена максимальная вместимость",
        NoTemplatesAvailable: "Шаблоны услуг недоступны",
        CreateBulkAvailableSlots: "Создать массовые свободные слоты",
        CreateMultipleBookings: "Создать несколько бронирований",
        AddMultipleDates: "Добавить несколько дат",
        DuplicateToMultipleDates: "Дублировать на несколько дат",
        BulkSlotsCreatedSuccess: "{count} свободных слотов успешно создано",
        BulkSlotsCreationFailed: "Не удалось создать доступные слоты",
        MultipleBookingsCreatedSuccess: "Успешно создано бронирований: {count}",
        MultipleBookingsCreatedPartial: "Создано {created}, пропущено {skipped}",
        SelectStartDate: "Выберите дату начала",
        SelectEndDate: "Выберите дату окончания",
        SelectStartTime: "Выберите время начала",
        SelectEndTime: "Выберите время окончания",
        PreferredTime: "Предпочтительное время",
        PreferredStartTime: "Предпочтительное время начала",
        PreferredTimeHelp: "При выборе даты система сначала попробует это время. Если оно занято, выберите одно из предложенных времен на этот день.",
        QuickTimes: "Быстрое время",
        NoQuickTimesYet: "Недавних времен пока нет",
        CustomPreferredTime: "Своё предпочтительное время",
        TemplateParticipants: "Участники",
        SelectAdditionalDates: "Выберите дополнительные даты",
        SelectAdditionalDatesHelp: "Зелёные дни поддерживают выбранное время. В янтарные дни доступны другие времена. Серые дни недоступны.",
        DayHasPreferredTime: "Предпочтительное время доступно",
        DayHasAlternativeTimes: "Доступны альтернативные времена",
        DayUnavailable: "Свободных времен нет",
        SelectedDates: "Выбранные даты",
        SelectedDatesCount: "Выбрано: {count}",
        NoDatesSelected: "Пока не выбрано ни одной даты",
        Ready: "Готово",
        NeedsTimeSelection: "Нужно время",
        ChooseTimeForDate: "Выберите время для этой даты",
        AvailableTimesForDay: "Доступное время на выбранную дату",
        SelectDateToSeeTimes: "Выберите дату, чтобы увидеть свободные времена",
        NoTimeSlotsAvailableForDate: "На эту дату нет свободного времени",
        LoadAvailabilityFailed: "Не удалось загрузить доступность",
        SelectedSlotNoLongerAvailable: "Выбранный слот больше недоступен. Пожалуйста, выберите заново.",
        BookingsCreatedCount: "Создано: {count}",
        BookingsSkippedCount: "Пропущено: {count}",
        BulkBookingFooterHelp: "Перед сохранением для каждой выбранной даты должно быть назначено время.",
        TemplateBuildFailed: "Не удалось подготовить шаблон бронирования",
        DaysOfWeek: "Дни недели",
        DaysOfWeekHelp: "Выберите, в какие дни недели создавать слоты",
        SlotDuration: "Продолжительность слота",
        UseDefaultRoom: "Использовать комнату по умолчанию (оставьте пустым)",
        RoomOptionalHelp: "Если комната не выбрана, будет использоваться комната сотрудника по умолчанию",
        CreationSummary: "Сводка создания",
        SlotsCreated: "Созданные слоты",
        SlotsSkipped: "Пропущенные слоты",
        SkippedDetails: "Детали пропущенных слотов",
        SlotsSkippedMessage: "{count} слотов было пропущено из-за конфликтов",
        FixedSlotTemplate: "Фиксированный слот услуги",
        FixedSlotMissingEmployee: "Сотрудник еще не назначен"
    },
    client: {
        ManageClients: "Управление клиентами",
        Clients: "Клиенты",
        Client: "Клиент",
        LeadClient: "Основной клиент",
        SelectClient: "Выберите клиента",
        ClientType: "Тип клиента",
        SelectClientType: "Выберите тип клиента",
        FilterByCategory: "Фильтр по категории",
        FilterByClientType: "Фильтр по типу клиента",
        DefaultLanguage: "Предпочитаемый язык",
        SelectDefaultLanguage: "Выберите предпочитаемый язык",
        DefaultLanguageHelp: "Язык для уведомлений и коммуникаций",
        PreferredService: "Предпочитаемый тип услуги",
        SelectPreferredService: "Выберите предпочитаемый тип услуги",
        PreferredServiceHelp: "Тип услуги, обычно используемый этим клиентом/ребенком для более быстрого бронирования",
        Notes: "Примечания",
        IsActive: "Активен",
        InactiveReason: "Причина неактивности",
        EnterInactiveReason: "Введите причину неактивности",
        InactiveReasonHelp: "Кратко опишите, почему клиент отмечен как неактивный. Например: обслуживание завершено, состояние восстановилось и услуга больше не нужна.",
        InactiveReasonRequired: "Для неактивного клиента необходимо указать причину",
        NoInactiveReasonProvided: "Причина не указана",
        InactiveStatusSummary: "Клиент отмечен как неактивный",
        HasUser: "Пользователь",
        HasUserAccount: "Есть пользователь",
        NoUserAccount: "Нет пользователя",
        UserAccount: "Учетная запись пользователя",
        NoClientRecordFound: "Для вашей учетной записи не найдена запись клиента",
        ContactAdministrator: "Пожалуйста, свяжитесь с администратором для получения помощи",
        Myself: "Для себя",
        SelectChild: "Выберите ребенка"
    },
    clientChild: {
        Name: "Имя",
        FirstName: "Имя",
        LastName: "Фамилия",
        IdentityCode: "Личный код",
        BirthDate: "Дата рождения",
        AddChild: "Добавить ребенка",
        EditChild: "Редактировать ребенка",
        DeleteChild: "Удалить ребенка",
        ChildDetails: "Данные ребенка",
        ParentClient: "Родительский клиент",
        NoChildren: "Нет зарегистрированных детей",
        ChildrenList: "Список детей",
        FirstNameRequired: "Имя обязательно",
        LastNameRequired: "Фамилия обязательна",
        IdentityCodeRequired: "Личный код обязателен",
        IdentityCodeInvalid: "Неверный эстонский личный код",
        BirthDateRequired: "Дата рождения обязательна",
        ChildCreatedSuccessfully: "Ребенок успешно добавлен",
        ChildUpdatedSuccessfully: "Данные ребенка успешно обновлены",
        ChildDeletedSuccessfully: "Ребенок успешно удален",
        FailedToCreateChild: "Не удалось добавить ребенка",
        FailedToUpdateChild: "Не удалось обновить данные ребенка",
        FailedToDeleteChild: "Не удалось удалить ребенка",
        FailedToLoadChildren: "Не удалось загрузить детей",
        ConfirmDeleteChild: "Вы уверены, что хотите удалить этого ребенка?",
        PromoteToAdult: "Сделать взрослым клиентом",
        PromoteConfirmation: "Вы уверены, что хотите сделать этого ребенка взрослым клиентом?",
        PromotedSuccessfully: "Ребенок успешно стал взрослым клиентом"
    },
    service: {
        ManageServices: "Управление услугами",
        Services: "Услуги",
        Service: "Услуга",
        Name: "Название услуги",
        ServiceName: "Название услуги",
        Category: "Категория",
        ServiceType: "Тип услуги",
        SelectServiceType: "Выберите тип услуги",
        ServiceTypeHelp: "Опциональная классификация для организации ваших услуг",
        Duration: "Продолжительность",
        Minutes: "минут",
        Price: "Цена",
        MaxCapacity: "Максимальная вместимость",
        Description: "Описание",
        IsActive: "Активна",
        IsPublic: "Публичная",
        IsPassEligible: "Подходит для абонемента",
        PassEligible: "Подходит для абонемента",
        ClientType: "Тип клиента",
        SelectClientType: "Выберите тип клиента",
        ClientTypeHelp: "Опционально - укажите, для какого типа клиента предназначена эта услуга (Взрослый, Ребенок и т.д.)",
        ServiceMarkedPublic: "Услуга отмечена как доступная для публичного бронирования",
        ServiceMarkedPrivate: "Услуга отмечена как приватная (недоступна для публичного бронирования)",
        ErrorUpdatingService: "Ошибка обновления услуги",
        CreateService: "Создать услугу",
        EditService: "Редактировать услугу",
        EnterName: "Введите название услуги",
        SelectCategory: "Выберите категорию",
        EnterDuration: "Введите продолжительность в минутах",
        EnterPrice: "Введите цену",
        EnterMaxCapacity: "Введите максимальную вместимость",
        EnterDescription: "Введите описание услуги",
        FilterByCategory: "Фильтр по категории",
        FilterByStatus: "Фильтр по статусу",
        ServiceSaved: "Услуга успешно сохранена",
        ServiceDeleted: "Услуга успешно удалена",
        ErrorLoadingService: "Ошибка загрузки услуги",
        ErrorSavingService: "Ошибка сохранения услуги",
        ErrorDeletingService: "Ошибка удаления услуги",
        ConfirmDelete: "Вы уверены, что хотите удалить эту услугу?",
        IndividualHelpText: "Индивидуальная терапия один на один",
        GroupHelpText: "Групповая терапия — несколько участников",
        IndividualCapacityFixed: "Вместимость индивидуальной услуги всегда 1",
        DisplayedAs: "Отображается как",
        QuickDuration: "Быстрый выбор продолжительности",
        Code: "Код услуги",
        CodePlaceholder: "например, PT-60, MT-45, GRP-T",
        CodeHelp: "Рекомендуемый формат: [Категория]-[Длительность]",
        AccountingCode: "Бухгалтерский код",
        AccountingCodePlaceholder: "например, ACCT-001",
        Color: "Цвет услуги",
        SelectColor: "Выберите цвет",
        IndividualServices: "Индивидуальные услуги",
        GroupServices: "Групповые услуги",
        RequiredSkills: "Требуемые навыки",
        SelectRequiredSkills: "Выберите требуемые навыки",
        RequiredSkillsHelp: "Сотрудники должны иметь эти навыки для предоставления этой услуги",
        AssignedEmployee: "Назначенный сотрудник",
        SelectService: "Выберите услугу",
        SelectEmployee: "Выберите сотрудника",
        SelectSkillsFirst: "Сначала выберите требуемые навыки",
        AssignedEmployeeHelp: "Сотрудник по умолчанию для этой услуги",
        AssignedRoom: "Назначенное помещение",
        SelectRoom: "Выберите помещение",
        AssignedRoomHelp: "Помещение по умолчанию для этой услуги",
        AddNewService: "Добавить новую услугу",
        IsSpecial: "Особая услуга (VIP/приоритет)",
        UseFixedSlots: "Использовать фиксированные недельные слоты",
        FixedSlotsHelp: "Когда включено, слоты публичного бронирования создаются только по этим правилам дня/времени.",
        FixedSlotTimeInvalid: "Введите время начала в формате HH:mm",
        StartTime: "Время начала",
        PassEligibilityEnabled: "Право на абонементы включено для {serviceName}",
        PassEligibilityDisabled: "Право на абонементы отключено для {serviceName}"
    },
    servicePass: {
        ServicePasses: "Абонементы на услуги",
        ServicePass: "Абонемент",
        Passes: "Абонементы",
        ManageServicePasses: "Управление абонементами",
        CreateServicePass: "Создать абонемент",
        EditServicePass: "Редактировать абонемент",
        PassDefinitions: "Определения абонементов",
        ClientPasses: "Абонементы клиентов",
        SelectClientToViewPasses: "Выберите клиента для просмотра его абонементов",
        SelectClientFirst: "Пожалуйста, сначала выберите клиента для просмотра его абонементов",
        Owner: "Владелец",
        Sessions: "Сеансы",
        PassName: "Название абонемента",
        PassNameHelp: "Название, которое видит клиент при покупке",
        PassDescription: "Описание",
        SessionCount: "Количество сеансов",
        Price: "Общая стоимость",
        ValidityDays: "Срок действия (дней)",
        IsActive: "Активен",
        PricePerSession: "Цена за сеанс",
        HasExpiry: "Имеет срок действия",
        SetExpiryPeriod: "Установить срок действия",
        NoExpiry: "Бессрочный",
        SelectService: "Выберите услугу",
        SelectServiceFirst: "Пожалуйста, сначала выберите услугу",
        EnterPassName: "Введите название абонемента",
        EnterDescription: "Введите описание",
        EnterSessionCount: "Введите количество сеансов",
        EnterPrice: "Введите общую стоимость",
        EnterValidityDays: "Введите срок действия в днях",
        SessionCountHelp: "Общее количество сеансов, включенных в этот абонемент",
        PriceHelp: "Общая стоимость всех сеансов в абонементе",
        ValidityDaysHelp: "Количество дней с даты покупки до истечения срока действия (оставьте пустым для бессрочного)",
        PassNameRequired: "Название абонемента обязательно",
        SessionCountRequired: "Количество сеансов обязательно",
        SessionCountRange: "Количество сеансов должно быть от 1 до 100",
        PriceRequired: "Цена обязательна",
        PricePositive: "Цена должна быть положительной",
        ValidityDaysRange: "Срок действия должен быть от 1 до 365 дней",
        ServicePassSaved: "Абонемент успешно сохранен",
        ServicePassDeleted: "Абонемент успешно удален",
        ErrorLoadingPasses: "Ошибка загрузки абонементов",
        ErrorSavingPass: "Ошибка сохранения абонемента",
        ErrorDeletingPass: "Ошибка удаления абонемента",
        ConfirmDelete: "Вы уверены, что хотите удалить этот абонемент?",
        EmptyStateMessage: "Для этой услуги не найдено абонементов. Создайте абонемент для предложения пакетов сеансов клиентам.",
        CreateFirstPass: "Создайте свой первый абонемент",
        MyPasses: "Мои абонементы",
        PurchasePass: "Купить абонемент",
        PassDetails: "Детали абонемента",
        RemainingSessionsLabel: "Осталось",
        SessionsUsed: "Использовано сеансов",
        PurchaseDate: "Дата покупки",
        ExpiryDate: "Срок действия",
        ExpiryDateOptional: "Срок действия необязателен. Оставьте пустым для бессрочного абонемента.",
        Status: "Статус",
        UsageHistory: "История использования",
        ViewUsageHistory: "Просмотр истории использования",
        ViewUsage: "Просмотр использования",
        NoUsageHistory: "История использования не найдена",
        UsedOn: "Использовано",
        BookingReference: "Ссылка на бронирование",
        Active: "Активен",
        Depleted: "Исчерпан",
        Expired: "Истек",
        Cancelled: "Отменен",
        PassPurchased: "Абонемент успешно приобретен",
        ErrorPurchasingPass: "Ошибка покупки абонемента",
        ErrorUpdatingPass: "Ошибка обновления абонемента",
        ErrorLoadingPassDetails: "Ошибка загрузки деталей абонемента",
        ErrorLoadingUsageHistory: "Ошибка загрузки истории использования",
        SelectPass: "Выберите абонемент",
        AvailablePasses: "Доступные абонементы",
        NoPasses: "Нет доступных абонементов",
        NoClientProfile: "Профиль клиента не найден. Пожалуйста, свяжитесь с поддержкой.",
        PassProgress: "Прогресс абонемента",
        SessionsRemaining: "Осталось сеансов: {count}",
        PassExpiring: "Истекает через {days} дней",
        PassExpired: "Срок действия этого абонемента истек",
        PurchaseForChild: "Опционально - купите этот абонемент для конкретного ребенка или оставьте пустым, чтобы купить для себя",
        ErrorLoadingServices: "Ошибка загрузки услуг",
        SearchClientOrChild: "Поиск клиента или ребенка",
        OwnerHelp: "Найдите и выберите клиента или его ребенка, который будет владеть этим абонементом",
        EditClientPass: "Редактировать абонемент клиента",
        EditNotSupported: "Редактирование купленных абонементов в настоящее время не поддерживается",
        HasActivePass: "Имеет активный абонемент для этой услуги",
        PassSessionsRemaining: "{remaining} из {total} сеансов осталось",
        RemainingSessions: "Осталось сеансов",
        RemainingSessionsHelp: "Необязательно: задайте начальное количество оставшихся сеансов для этого абонемента.",
        RemainingSessionsPlaceholder: "По умолчанию: {total}",
        SessionsUsedHelp: "Укажите, сколько раз абонемент уже был использован. Это изменит оставшиеся сеансы, но не добавит записи в историю использования задним числом.",
        AddBookingUsage: "Добавить использованное бронирование",
        AddBookingUsageHelp: "Откройте список и выберите существующее прошедшее бронирование для того же владельца и той же услуги.",
        SelectBookingUsage: "Выбрать использованное бронирование",
        SelectBookingUsageHelp: "Показаны только прошедшие бронирования того же владельца и той же услуги, которые еще не связаны с этим абонементом.",
        EligibleBookings: "Подходящих бронирований: {count}",
        NoEligibleBookingsForPass: "Для этого абонемента подходящие бронирования не найдены.",
        ErrorLoadingEligibleBookings: "Не удалось загрузить подходящие бронирования",
        BookingUsageAdded: "Бронирование добавлено в историю использования абонемента",
        ErrorAddingBookingUsage: "Не удалось добавить бронирование в историю использования абонемента",
        ActiveServicePasses: "Активные абонементы",
        NoPassEligibleServices: "Услуги, подходящие для абонементов, не найдены. Сначала включите право на абонементы в настройках услуги.",
        OnlyPassEligibleServicesShown: "Показаны только услуги, подходящие для абонементов.",
        ManageServices: "Управление услугами",
        ManagePassEligibility: "Управление правом на абонементы",
        BeforeBooking: "до бронирования"
    },
    employee: {
        Employees: "Сотрудники",
        Employee: "Сотрудник",
        ManageEmployees: "Управление сотрудниками",
        CreateEmployee: "Создать сотрудника",
        EditEmployee: "Редактировать сотрудника",
        EmployeeDetail: "Детали сотрудника",
        Name: "Имя",
        FirstName: "Имя",
        LastName: "Фамилия",
        Email: "Email",
        Phone: "Телефон",
        User: "Пользователь",
        Status: "Статус",
        Skills: "Навыки",
        IsActive: "Активен",
        BasicInfo: "Основная информация",
        Qualifications: "Квалификации",
        WorkSchedules: "Рабочие графики",
        Unavailability: "Недоступность",
        SelectEmployee: "Выберите сотрудника",
        SelectStatus: "Выберите статус",
        SelectSkills: "Выберите навыки",
        EnterFirstName: "Введите имя",
        EnterLastName: "Введите фамилию",
        EnterEmail: "Введите адрес электронной почты",
        EnterPhone: "Введите номер телефона",
        FirstNameRequired: "Имя обязательно",
        LastNameRequired: "Фамилия обязательна",
        StatusRequired: "Статус обязателен",
        EmployeeCreated: "Сотрудник успешно создан",
        EmployeeUpdated: "Сотрудник успешно обновлен",
        EmployeeDeleted: "Сотрудник успешно удален",
        SaveFailed: "Не удалось сохранить сотрудника",
        LoadFailed: "Не удалось загрузить данные сотрудника",
        SkillsDescription: "Управление навыками и компетенциями сотрудника",
        QualificationsDescription: "Отслеживание квалификаций, сертификатов и сроков действия сотрудника",
        WorkSchedulesDescription: "Определение повторяющихся рабочих графиков и шаблонов доступности",
        UnavailabilityDescription: "Управление отсутствиями сотрудника и блокировкой свободных слотов",
        QualificationsComingSoon: "Управление квалификациями скоро появится",
        WorkSchedulesComingSoon: "Управление рабочими графиками скоро появится",
        UnavailabilityComingSoon: "Управление недоступностью скоро появится",
        FilterByActive: "Фильтр по активности",
        AcquiredDate: "Дата получения",
        ExpiresOn: "Истекает",
        CertificationNumber: "Номер сертификата",
        NoExpiry: "Без срока",
        Expired: "Истек",
        ExpiringSoon: "Истекает через {days} дней",
        Valid: "Действителен",
        NoQualifications: "Квалификации не назначены",
        AddQualification: "Добавить квалификацию",
        EditQualification: "Редактировать квалификацию",
        QualificationRequired: "Квалификация обязательна",
        QualificationSaved: "Квалификация успешно сохранена",
        SaveQualificationFailed: "Не удалось сохранить квалификацию",
        LoadQualificationsFailed: "Не удалось загрузить квалификации",
        SelectAcquiredDate: "Выберите дату получения",
        SelectExpiryDate: "Выберите дату истечения (необязательно)",
        ExpiryDateOptional: "Оставьте пустым, если квалификация не имеет срока действия",
        EnterCertificationNumber: "Введите номер сертификата/лицензии",
        EnterNotes: "Введите дополнительные примечания",
        Absences: "Отсутствия",
        CreateAbsence: "Создать отсутствие",
        EditAbsence: "Редактировать отсутствие",
        AbsenceCreated: "Отсутствие успешно создано",
        AbsenceDeleted: "Отсутствие успешно удалено",
        AbsenceFailed: "Не удалось управлять отсутствием",
        LoadAbsencesFailed: "Не удалось загрузить отсутствия",
        NoAbsences: "Отсутствия не зарегистрированы",
        AbsenceStartTime: "Начало отсутствия",
        AbsenceEndTime: "Конец отсутствия",
        AbsenceReason: "Причина отсутствия",
        AbsenceReasonOptional: "Причина необязательна",
        SelectAbsenceReason: "Выберите причину (необязательно)",
        AbsenceStartRequired: "Время начала обязательно",
        AbsenceEndRequired: "Время окончания обязательно",
        AbsenceCannotBePast: "Отсутствие не может быть в прошлом",
        AbsenceOverlapError: "Это отсутствие пересекается с существующим отсутствием",
        AbsenceAffectedBookings: "Затронутые бронирования",
        AbsenceSubstituteMatch: "Замена найдена",
        AbsenceNoSubstitute: "Замена недоступна",
        AbsenceBookingsWillBeCancelled: "Затронутые бронирования будут отменены, если замена не найдена",
        AbsenceBookingsReassigned: "Бронирования переназначены на замену",
        AbsenceBookingsCancelled: "Бронирования отменены",
        AbsenceDeleteWarning: "Удаление этого отсутствия НЕ восстановит отмененные бронирования",
        AbsenceAllDay: "Весь день",
        AllDayAbsenceInfo: "Отсутствие действует в течение всего дня (00:00 – 24:00). Время окончания автоматически устанавливается на начало следующего дня.",
        NoReasonProvided: "Причина не указана",
        DefaultRoom: "Комната по умолчанию",
        SelectDefaultRoom: "Выберите комнату по умолчанию (необязательно)",
        DefaultRoomHelp: "Эта комната будет использоваться по умолчанию при создании доступных слотов",
        NoEmployeeRecordFound: "Запись о сотруднике не найдена для вашей учетной записи",
        ContactAdministrator: "Пожалуйста, свяжитесь с администратором, чтобы связать вашу учетную запись с записью сотрудника",
        // Work Schedule Management
        NoSchedules: "Нет определенных графиков работы",
        AddFirstSchedule: "Добавьте свой первый график работы",
        AddSchedule: "Добавить график",
        EditSchedule: "Редактировать график",
        DayOfWeek: "День недели",
        StartTime: "Время начала",
        EndTime: "Время окончания",
        RecurringPattern: "Шаблон повторения",
        SelectRecurringPattern: "Выберите шаблон повторения",
        EffectiveFrom: "Действует с",
        EffectiveTo: "Действует до",
        SelectDate: "Выбрать дату",
        SelectDay: "Выбрать день",
        SelectDays: "Выбрать дни",
        TimeFormat: "ЧЧ:ММ",
        ScheduleCreated: "График успешно создан",
        ScheduleUpdated: "График успешно обновлен",
        FailedToLoadSchedules: "Не удалось загрузить графики",
        FailedToSaveSchedule: "Не удалось сохранить график"
    },
    qualification: {
        Qualifications: "Квалификации",
        Qualification: "Квалификация",
        ManageQualifications: "Управление квалификациями",
        Name: "Название квалификации",
        Code: "Код квалификации",
        Description: "Описание",
        Category: "Категория",
        IsActive: "Активна",
        RequiresExpiry: "Требует истечения срока",
        ValidityPeriodMonths: "Срок действия (месяцы)",
        CreateQualification: "Создать квалификацию",
        EditQualification: "Редактировать квалификацию",
        EnterName: "Введите название квалификации",
        EnterCode: "Введите код квалификации",
        EnterDescription: "Введите описание",
        SelectCategory: "Выберите категорию",
        EnterValidityPeriod: "Введите срок действия в месяцах",
        QualificationSaved: "Квалификация успешно сохранена",
        QualificationDeleted: "Квалификация успешно удалена",
        ErrorLoadingQualifications: "Ошибка загрузки квалификаций",
        ErrorLoadingQualification: "Ошибка загрузки квалификации",
        ErrorSavingQualification: "Ошибка сохранения квалификации",
        ErrorDeletingQualification: "Ошибка удаления квалификации",
        NoQualificationsFound: "Квалификации не найдены",
        ValidityPeriodHelp: "Количество месяцев, в течение которых квалификация остается действительной (например, 12 для ежегодного продления)",
        RequiresExpiryHelp: "Включите, если эта квалификация требует периодического продления"
    },
    room: {
        Room: "Комната",
        Rooms: "Комнаты",
        RoomList: "Список комнат",
        RoomDetails: "Детали комнаты",
        CreateRoom: "Создать комнату",
        EditRoom: "Редактировать комнату",
        DeleteRoom: "Удалить комнату",
        Name: "Название комнаты",
        Description: "Описание",
        Location: "Местоположение",
        Capacity: "Вместимость",
        IsActive: "Активна",
        SelectRoom: "Выберите комнату",
        NameRequired: "Название комнаты обязательно",
        CapacityRequired: "Вместимость обязательна",
        CapacityRange: "Вместимость должна быть от 1 до 100",
        InsufficientCapacity: "Вместимость комнаты ({roomCapacity}) недостаточна для максимальной вместимости услуги ({serviceCapacity})",
        RoomCreated: "Комната успешно создана",
        RoomUpdated: "Комната успешно обновлена",
        RoomDeleted: "Комната успешно удалена",
        CannotDeleteWithBookings: "Невозможно удалить комнату с будущими бронированиями",
        ErrorLoadingRooms: "Ошибка загрузки комнат",
        ErrorSavingRoom: "Ошибка сохранения комнаты",
        ErrorDeletingRoom: "Ошибка удаления комнаты",
        EmptyStateMessage: "Комнаты не найдены. Создайте свою первую терапевтическую комнату для начала бронирования сеансов.",
        CreateFirstRoom: "Создать первую комнату",
        EnterName: "Введите название комнаты",
        EnterDescription: "Введите описание",
        EnterLocation: "Введите местоположение",
        EnterCapacity: "Введите вместимость",
        HasFutureBookings: "У этой комнаты есть {count} будущих бронирований и её нельзя удалить"
    },
    suggestion: {
        Suggestions: "Предложения",
        MySuggestions: "Мои предложения",
        ClientSuggestions: "Предложения клиента",
        AddSuggestion: "Добавить предложение",
        EditSuggestion: "Редактировать предложение",
        Suggestion: "Предложение",
        Title: "Заголовок",
        Description: "Описание",
        Date: "Дата",
        Client: "Клиент",
        Therapist: "Терапевт",
        DueDate: "Срок выполнения",
        Status: "Статус",
        CompletedDate: "Дата завершения",
        CreatedDate: "Дата создания",
        MarkAsDone: "Отметить как выполненное",
        MarkAsCompleted: "Отметить как завершенное",
        Done: "Выполнено",
        Completed: "Завершено",
        Overdue: "Просрочено",
        NoSuggestionsFound: "Предложения не найдены",
        ConfirmMarkAsCompleted: "Вы уверены, что хотите отметить это предложение как завершенное?",
        ConfirmDelete: "Вы уверены, что хотите удалить предложение '{title}'?",
        MarkedAsCompletedSuccess: "Предложение успешно отмечено как завершенное",
        MarkedAsCompletedError: "Не удалось отметить предложение как завершенное",
        LoadError: "Не удалось загрузить предложения",
        CreateSuccess: "Предложение успешно создано",
        UpdateSuccess: "Предложение успешно обновлено",
        DeleteSuccess: "Предложение успешно удалено",
        SaveError: "Не удалось сохранить предложение",
        DeleteError: "Не удалось удалить предложение",
        TitleRequired: "Заголовок обязателен",
        EnterTitle: "Введите заголовок",
        EnterDescription: "Введите описание (необязательно)",
        SelectDueDate: "Выберите срок выполнения (необязательно)",
        DueDateHint: "Выберите целевую дату завершения",
        SelectStatus: "Выберите статус",
        CreateSuggestion: "Создать предложение",
        AddFromBookingHint: "Создать предложение для этого клиента на основе этого сеанса бронирования"
    },
    notification: {
        ManageNotifications: "Управление уведомлениями",
        ManageNotificationsDescription: "Просмотр и управление всеми системными уведомлениями, включая статус доставки и возможность повторной отправки",
        NotificationManagement: "Управление уведомлениями",
        NotificationList: "Список уведомлений",
        NotificationId: "ID",
        NotificationDetails: "Детали уведомления",
        User: "Пользователь",
        Title: "Заголовок",
        Message: "Сообщение",
        Type: "Тип",
        Status: "Статус",
        Sent: "Отправлено",
        NotSent: "Не отправлено",
        Read: "Прочитано",
        Abandoned: "Отклонено",
        RetryCount: "Количество попыток",
        Booking: "Бронирование",
        RelatedBooking: "Связанное бронирование",
        CreatedOn: "Создано",
        SentOn: "Отправлено",
        IsSent: "Отправлено",
        IsRead: "Прочитано",
        IsAbandoned: "Отклонено",
        IsEmailSent: "Email отправлен",
        EmailSentOn: "Email отправлен",
        EmailRetryCount: "Количество попыток email",
        EmailSent: "Email отправлен",
        EmailPending: "Email в ожидании",
        FilterByUser: "Фильтр по ID пользователя",
        FilterBySent: "Фильтр по отправленным",
        FilterByRead: "Фильтр по прочитанным",
        FilterByAbandoned: "Фильтр по отклоненным",
        UserIdPlaceholder: "Введите ID пользователя",
        ResendNotification: "Отправить уведомление повторно",
        ConfirmResend: "Подтвердить повторную отправку",
        ConfirmResendMessage: "Вы уверены, что хотите отправить это уведомление повторно?",
        Resend: "Отправить повторно",
        ResendSuccess: "Уведомление успешно отправлено повторно",
        ResendFailed: "Не удалось отправить уведомление повторно",
        ResendError: "Ошибка при повторной отправке уведомления",
        LoadNotificationsError: "Не удалось загрузить уведомления",
        NoNotificationsFound: "Уведомления не найдены",
        DeliveryStatus: "Статус доставки",
        SignalRSentOn: "SignalR отправлено",
        SignalRRetryCount: "Количество попыток SignalR",
        ReadOn: "Прочитано",
        NotRead: "Не прочитано",
    },
    user: {
        UserManagement: "Управление пользователями",
        Users: "Пользователи",
        User: "Пользователь",
        Username: "Имя пользователя",
        Password: "Пароль",
        ChangePassword: "Сменить пароль",
        ChangePasswordMsg: "Ваш пароль был успешно изменен.",
        ErrorAtLogging: "Произошла ошибка при входе в систему.",
        SuccessfullyLogged: "Успешно вошли в систему.",
        EmployeeName: "Имя сотрудника",
        Role: "Роль",
        CreateUser: "Создать пользователя",
        EditUser: "Редактировать пользователя",
        DeleteUser: "Удалить пользователя",
        SearchByUsernameOrEmail: "Поиск по имени пользователя или email",
        FilterByRole: "Фильтр по роли",
        SelectRole: "Выберите роль",
        RoleHelperText: "Выберите роль для этого пользователя",
        UsernameRequired: "Имя пользователя обязательно",
        PasswordRequired: "Пароль обязателен",
        RoleRequired: "Роль обязательна",
        UserSavedSuccessfully: "Пользователь успешно сохранён",
        UserDeletedSuccessfully: "Пользователь успешно удалён",
        ErrorLoadingUsers: "Ошибка загрузки пользователей",
        ErrorSavingUser: "Ошибка сохранения пользователя",
        ErrorDeletingUser: "Ошибка удаления пользователя",
        CannotDeleteYourself: "Вы не можете удалить свою учётную запись",
        CannotDeleteSystemAdmin: "Невозможно удалить системного администратора",
        ComingSoon: "Управление пользователями скоро - требуется реализация API",
        ResetPassword: "Сбросить пароль",
        ResetPasswordConfirmTitle: "Сбросить пароль?",
        ResetPasswordConfirmMessage: "Вы уверены, что хотите сбросить пароль для пользователя '{0}'? Письмо для сброса пароля будет отправлено на их адрес электронной почты.",
        PasswordResetSuccess: "Письмо для сброса пароля успешно отправлено",
        PasswordResetError: "Не удалось отправить письмо для сброса пароля",
        UserDetail: "Детали пользователя",
        RelatedTo: "Связано с",
        RelatedEntity: "Связанная запись",
        CanViewAllEntries: "Видит все записи",
        CanViewAllEntriesHelperText: "Если пользователь связан с сотрудником, это позволяет ему видеть записи всех сотрудников, а не только свои.",
        Employee: "Сотрудник",
        Client: "Клиент",
        NotLinked: "Не связано",
        OpenClientDetail: "Открыть клиента",
        OpenEmployeeDetail: "Открыть сотрудника",
        UnlinkRelation: "Отвязать связь",
        UnlinkRelationConfirmTitle: "Отвязать связь пользователя?",
        UnlinkRelationConfirmMessage: "Вы уверены, что хотите отвязать пользователя \"{userName}\" от связанного профиля клиента/сотрудника?",
        UnlinkRelationSuccess: "Связь пользователя успешно удалена",
        UnlinkRelationError: "Не удалось отвязать связь пользователя",
    },
    role: {
        RoleManagement: "Управление ролями",
        Roles: "Роли",
        Role: "Роль",
        RoleName: "Название роли",
        RoleCode: "Код роли",
        Privileges: "Привилегии",
        PrivilegeCount: "Количество привилегий",
        CreateRole: "Создать роль",
        EditRole: "Редактировать роль",
        DeleteRole: "Удалить роль",
        SearchByRoleName: "Поиск по названию роли",
        SelectPrivileges: "Выберите привилегии",
        RoleNameRequired: "Название роли обязательно",
        RoleCodeRequired: "Код роли обязателен",
        RoleSavedSuccessfully: "Роль успешно сохранена",
        RoleDeletedSuccessfully: "Роль успешно удалена",
        ErrorLoadingRoles: "Ошибка загрузки ролей",
        ErrorSavingRole: "Ошибка сохранения роли",
        ErrorDeletingRole: "Ошибка удаления роли",
        CannotDeleteSystemRole: "Невозможно удалить системную роль",
        CannotDeleteRoleWithUsers: "Невозможно удалить роль с назначенными пользователями",
        ComingSoon: "Управление ролями скоро - требуется реализация API"
    },
    security: {
        ActiveSessions: "Активные сеансы",
        Session: "Сеанс",
        NoActiveSessions: "Активные сеансы не найдены",
        IpAddress: "IP-адрес",
        UserAgent: "User Agent",
        CreatedOn: "Создано",
        LastAccessed: "Последний доступ",
        ExpiresAt: "Истекает",
        InvalidateSession: "Выйти",
        ConfirmInvalidateSession: "Вы уверены, что хотите выйти из этого сеанса?",
        SessionInvalidated: "Сеанс успешно завершен",
        FailedToLoadSessions: "Не удалось загрузить сеансы",
        FailedToInvalidateSession: "Не удалось завершить сеанс",
        LoginAttempts: "Попытки входа",
        NoLoginAttempts: "Попытки входа не найдены",
        Successful: "Успешно",
        Failed: "Неудачно",
        FailureReason: "Причина",
        AttemptedAt: "Попытка"
    },
    clientInvitation: {
        CompleteRegistration: "Завершить регистрацию",
        CompleteRegistrationDescription: "Создайте пароль, чтобы завершить настройку учетной записи",
        Password: "Пароль",
        ConfirmPassword: "Подтвердите пароль",
        EnterPassword: "Введите пароль",
        EnterConfirmPassword: "Введите пароль еще раз",
        PasswordHint: "Пароль должен содержать не менее 8 символов",
        PasswordTooShort: "Пароль должен содержать не менее 8 символов",
        PasswordMismatch: "Пароли не совпадают",
        InvitationExpires: "Срок действия этого приглашения истекает",
        InvalidInvitationLink: "Недействительная ссылка приглашения",
        InvitationInvalidOrExpired: "Это приглашение недействительно или истекло",
        InvitationExpired: "Срок действия этого приглашения истек",
        InvitationAlreadyUsed: "Это приглашение уже использовано",
        FailedToLoadInvitation: "Не удалось загрузить детали приглашения",
        RegistrationCompleteSuccess: "Регистрация успешно завершена! Перенаправление на страницу входа...",
        RegistrationFailed: "Регистрация не удалась. Пожалуйста, попробуйте еще раз.",
        EmailAlreadyRegistered: "Этот адрес электронной почты уже зарегистрирован",
        SendInvitation: "Отправить приглашение",
        InvitationPrompt: "У клиента еще нет учетной записи пользователя. Отправьте приглашение для ее создания.",
        ResendInvitation: "Отправить приглашение повторно",
        InvitationSent: "Приглашение успешно отправлено",
        InvitationResent: "Приглашение успешно отправлено повторно",
        FailedToSendInvitation: "Не удалось отправить приглашение",
        ConfirmSendInvitation: "Вы уверены, что хотите отправить приглашение этому клиенту?",
        ClientHasNoEmail: "У клиента нет адреса электронной почты"
    },
    employeeInvitation: {
        SendInvitation: "Отправить приглашение",
        InvitationPrompt: "У сотрудника еще нет учетной записи пользователя. Отправьте приглашение для ее создания.",
        InvitationSent: "Приглашение успешно отправлено",
        FailedToSendInvitation: "Не удалось отправить приглашение",
        ConfirmSendInvitation: "Отправить приглашение этому сотруднику?",
        EmployeeHasNoEmail: "У сотрудника нет адреса электронной почты"
    },
    public: {
        WelcomeToRuumi: "Добро пожаловать в Akersoni teenused",
        SelectServiceToBook: "Выберите услугу для записи на терапевтический сеанс",
        SelectServiceCategoryToBook: "Выберите категорию услуги для записи на терапевтический сеанс",
        BookNow: "Записаться сейчас",
        NoServicesAvailable: "В данный момент услуги недоступны",
        SelectDate: "Выберите дату",
        SelectTimeSlot: "Выберите временной интервал",
        SelectTime: "Выберите время",
        SelectClientType: "Выберите тип клиента",
        SelectedService: "Выбранная услуга",
        AvailableFor: "Доступно для",
        Available: "Доступно",
        YourInformation: "Ваша информация",
        ClientDetails: "Данные клиента",
        ProceedToPayment: "Перейти к оплате",
        PaymentTermsHeading: "Условия оплаты",
        TermsAgreementLabel: "Я согласен(а) с условиями оплаты",
        TermsRequired: "Пожалуйста, примите условия оплаты, чтобы продолжить.",
        ViewFullTerms: "Посмотреть полные условия",
        PaymentMethod: "Способ оплаты",
        SelectPaymentMethod: "Выберите способ оплаты",
        PayWithCard: "Оплатить картой",
        UseServicePass: "Использовать абонемент",
        ServicePassAvailable: "Доступен абонемент: {name} (осталось {remaining} сеансов)",
        ServicePassUnavailable: "Нет активного абонемента для этой услуги.",
        CheckingServicePass: "Проверяем абонемент...",
        ConfirmWithServicePass: "Подтвердить с абонементом",
        ServiceNotAvailable: "Услуга недоступна для этой комбинации. Пожалуйста, попробуйте другой выбор.",
        ValidatingPayment: "Проверка платежа...",
        PaymentSuccessful: "Оплата прошла успешно!",
        BookingConfirmed: "Ваша запись подтверждена",
        BookingReference: "Номер записи",
        PaymentStatus: "Статус платежа",
        CheckYourEmail: "Проверьте вашу электронную почту",
        EmailSentWithDetails: "Мы отправили вам письмо с подтверждением и всеми подробностями вашей записи.",
        CreateAccount: "Создать аккаунт",
        BackToHome: "Вернуться на главную",
        PaymentFailed: "Платеж не прошел",
        PaymentValidationError: "Произошла ошибка при проверке вашего платежа. Пожалуйста, попробуйте снова или обратитесь в службу поддержки.",
        NoChargeApplied: "С вашего счета не было снято средств.",
        TryBookingAgain: "Попробовать записаться снова",
        TryAgain: "Попробовать снова",
        ContactSupport: "Связаться с поддержкой",
        MissingOrderToken: "Отсутствует токен заказа в URL. Невозможно проверить платеж.",
        ValidationRequestFailed: "Не удалось отправить запрос на проверку платежа. Пожалуйста, проверьте интернет-соединение и попробуйте снова.",
        PaymentInitiationFailed: "Не удалось инициировать платеж. Пожалуйста, попробуйте снова.",
        NoTimeSlotsAvailable: "Нет доступных временных интервалов для выбранной даты. Пожалуйста, выберите другую дату.",
        CheckingAvailability: "Проверка доступности...",
        PersonalId: "Личный код",
        DateOfBirth: "Дата рождения",
        ClientType: "Тип клиента",
        NoteToTherapist: "Заметка для терапевта (необязательно)",
        PersonalIdPlaceholder: "Введите эстонский личный код",
        DateOfBirthPlaceholder: "Выберите дату рождения",
        NotePlaceholder: "Особые заметки или требования..."
    }
};

export default ruLocale;
